//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ContactRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the contacts export file.
     * @param interventionId The intervention identifier.
     * @return The csv file.
     */
    getContactsExportFile(interventionId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/contact/GetContactsExportFile?";
        if (interventionId === undefined || interventionId === null)
            throw new Error("The parameter 'interventionId' must be defined and cannot be null.");
        else
            url_ += "interventionId=" + encodeURIComponent("" + interventionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContactsExportFile(_response);
        });
    }

    protected processGetContactsExportFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class MembersRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Adds a managed operator to specified member.
     * @param email The email.
     * @param managedOperatorId The managed operator identifier.
     */
    addManagedOperator(email: string | null, managedOperatorId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/member/AddManagedOperator?";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else if(email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (managedOperatorId === undefined || managedOperatorId === null)
            throw new Error("The parameter 'managedOperatorId' must be defined and cannot be null.");
        else
            url_ += "managedOperatorId=" + encodeURIComponent("" + managedOperatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddManagedOperator(_response);
        });
    }

    protected processAddManagedOperator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates the specified member.
     * @param createMember The create member.
     * @return The id of the created member.
     */
    create(createMember: CreateMember | null): Promise<StatusValueResponseOfInteger | null> {
        let url_ = this.baseUrl + "/api/member/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createMember);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<StatusValueResponseOfInteger | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResponseOfInteger.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusValueResponseOfInteger | null>(null as any);
    }

    /**
     * Gets the member.
     * @param id The identifier.
     * @return The member.
     */
    getMember(id: number): Promise<Member | null> {
        let url_ = this.baseUrl + "/api/member/GetMember/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMember(_response);
        });
    }

    protected processGetMember(response: Response): Promise<Member | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Member.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Member | null>(null as any);
    }

    /**
     * Gets the members matching the search parameters.
     * @param searchParams The search parameters.
     * @return The members matching the search parameters.
     */
    getMembers(searchParams: MemberPaginatedSearchParams | null): Promise<MemberLight[] | null> {
        let url_ = this.baseUrl + "/api/member/GetMembers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMembers(_response);
        });
    }

    protected processGetMembers(response: Response): Promise<MemberLight[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberLight[] | null>(null as any);
    }

    /**
     * Updates the specified member.
     * @param updateMember The update member.
     */
    update(updateMember: UpdateMember | null): Promise<void> {
        let url_ = this.baseUrl + "/api/member/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateMember);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param id The identifier.
     */
    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/member/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class InterventionRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Cancels the specified intervention identifier.
     * @param interventionId The intervention identifier.
     */
    cancel(interventionId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/intervention/Cancel?";
        if (interventionId === undefined || interventionId === null)
            throw new Error("The parameter 'interventionId' must be defined and cannot be null.");
        else
            url_ += "interventionId=" + encodeURIComponent("" + interventionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates the specified intervention.
     * @param createIntervention The create intervention.
     * @return The id of the created intervention.
     */
    create(createIntervention: CreateIntervention | null): Promise<StatusValueResponseOfInteger | null> {
        let url_ = this.baseUrl + "/api/intervention/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createIntervention);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<StatusValueResponseOfInteger | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResponseOfInteger.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusValueResponseOfInteger | null>(null as any);
    }

    /**
     * Gets the intervention.
     * @param id The identifier.
     * @return The intervention.
     */
    getIntervention(id: number): Promise<Intervention | null> {
        let url_ = this.baseUrl + "/api/intervention/GetIntervention/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIntervention(_response);
        });
    }

    protected processGetIntervention(response: Response): Promise<Intervention | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Intervention.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Intervention | null>(null as any);
    }

    /**
     * Gets the interventions matching the search parameters.
     * @param searchParams The search parameters.
     * @return The interventions matching the search parameters.
     */
    getInterventions(searchParams: InterventionPaginatedSearchParams | null): Promise<InterventionLight[] | null> {
        let url_ = this.baseUrl + "/api/intervention/GetInterventions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInterventions(_response);
        });
    }

    protected processGetInterventions(response: Response): Promise<InterventionLight[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InterventionLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterventionLight[] | null>(null as any);
    }

    /**
     * Gets the interventions and unauthorized openings export file.
     * @param parameters The export parameters.
     * @return The CSV file.
     */
    getInterventionsAndUnauthorizedOpeningsExportFile(parameters: InterventionExportParams | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/intervention/GetInterventionsAndUnauthorizedOpeningsExportFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInterventionsAndUnauthorizedOpeningsExportFile(_response);
        });
    }

    protected processGetInterventionsAndUnauthorizedOpeningsExportFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Gets the interventions and non authorized openings for cabinet.
     * @param searchParams The search parameters.
     * @return The list of the intervention and the unauthorized opening.
     */
    getInterventionsAndNonAuthorizedOpeningsForCabinet(searchParams: InterventionPaginatedLiteSearchParams | null): Promise<InterventionAndUnauthorizedOpeningWrapper[] | null> {
        let url_ = this.baseUrl + "/api/intervention/GetInterventionsAndNonAuthorizedOpeningsForCabinet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInterventionsAndNonAuthorizedOpeningsForCabinet(_response);
        });
    }

    protected processGetInterventionsAndNonAuthorizedOpeningsForCabinet(response: Response): Promise<InterventionAndUnauthorizedOpeningWrapper[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InterventionAndUnauthorizedOpeningWrapper.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterventionAndUnauthorizedOpeningWrapper[] | null>(null as any);
    }

    /**
     * Updates the specified intervention.
     * @param updateIntervention The update intervention.
     */
    update(updateIntervention: UpdateIntervention | null): Promise<void> {
        let url_ = this.baseUrl + "/api/intervention/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateIntervention);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StatisticsRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the statistics.
     * @param searchParams The search parameters.
     * @return The statistics.
     */
    getStatistics(searchParams: StatisticsSearchParams | null): Promise<Statistics | null> {
        let url_ = this.baseUrl + "/api/statistics/GetStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatistics(_response);
        });
    }

    protected processGetStatistics(response: Response): Promise<Statistics | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Statistics.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Statistics | null>(null as any);
    }
}

export class TwilioRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Test send SMS.
     * @return The result.
     */
    sendMessage(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/twilio/SendMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendMessage(_response);
        });
    }

    protected processSendMessage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Posts the message.
     * @param smsRequest The SMS request.
     * @return The result.
     */
    postMessage(smsRequest: SmsRequest | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/twilio/PostMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(smsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMessage(_response);
        });
    }

    protected processPostMessage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class TechnicianRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Creates the specified technician.
     * @param createTechnician The create technician.
     * @return The id of the created technician.
     */
    create(createTechnician: CreateTechnician | null): Promise<StatusValueResponseOfInteger | null> {
        let url_ = this.baseUrl + "/api/technician/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createTechnician);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<StatusValueResponseOfInteger | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResponseOfInteger.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusValueResponseOfInteger | null>(null as any);
    }

    /**
     * Disables the specified identifier.
     * @param id The identifier.
     */
    disable(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/technician/Disable/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDisable(_response);
        });
    }

    protected processDisable(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Enables the specified identifier.
     * @param id The identifier.
     */
    enable(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/technician/Enable/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnable(_response);
        });
    }

    protected processEnable(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the technician.
     * @param id The identifier.
     * @return The technician.
     */
    getTechnician(id: number): Promise<Technician | null> {
        let url_ = this.baseUrl + "/api/technician/GetTechnician/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTechnician(_response);
        });
    }

    protected processGetTechnician(response: Response): Promise<Technician | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Technician.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Technician | null>(null as any);
    }

    /**
     * Gets the technicians matching the search parameters.
     * @param searchParams The search parameters.
     * @return The technicians matching the search parameters.
     */
    getTechnicians(searchParams: TechnicianPaginatedSearchParams | null): Promise<TechnicianLight[] | null> {
        let url_ = this.baseUrl + "/api/technician/GetTechnicians";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTechnicians(_response);
        });
    }

    protected processGetTechnicians(response: Response): Promise<TechnicianLight[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TechnicianLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TechnicianLight[] | null>(null as any);
    }

    /**
     * Gets the technicians export file.
     * @return The CSV file.
     */
    getTechniciansExportFile(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/technician/GetTechniciansExportFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTechniciansExportFile(_response);
        });
    }

    protected processGetTechniciansExportFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Gets the technicians as select items.
     * @param searchParams The search parameters.
     * @return The technicians as select items.
     */
    getTechniciansAsSelectItems(searchParams: TechnicianSearchParams | null): Promise<SelectItemOfInteger[] | null> {
        let url_ = this.baseUrl + "/api/technician/GetTechniciansAsSelectItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTechniciansAsSelectItems(_response);
        });
    }

    protected processGetTechniciansAsSelectItems(response: Response): Promise<SelectItemOfInteger[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItemOfInteger.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItemOfInteger[] | null>(null as any);
    }

    /**
     * Imports the technicians from the file (csv).
     * @param technicianImport The technician import.
     * @return The import errors, empty if success.
     */
    import(technicianImport: TechnicianImport | null): Promise<TechnicianImportError[] | null> {
        let url_ = this.baseUrl + "/api/technician/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(technicianImport);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: Response): Promise<TechnicianImportError[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TechnicianImportError.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TechnicianImportError[] | null>(null as any);
    }

    /**
     * Updates the specified technician.
     * @param updateTechnician The update technician.
     */
    update(updateTechnician: UpdateTechnician | null): Promise<void> {
        let url_ = this.baseUrl + "/api/technician/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTechnician);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Refresh the TechnicianIdAuth from an technician.
     * @param technicianId The technicianId.
     */
    refreshTechnicianIdAuth(technicianId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/technician/RefreshTechnicianIdAuth?";
        if (technicianId === undefined || technicianId === null)
            throw new Error("The parameter 'technicianId' must be defined and cannot be null.");
        else
            url_ += "technicianId=" + encodeURIComponent("" + technicianId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefreshTechnicianIdAuth(_response);
        });
    }

    protected processRefreshTechnicianIdAuth(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Authorise the Pwa Token.
     * @param authToken The authToken.
     * @return The IdToken.
     */
    getIdToken(authToken: string | null): Promise<StatusValueResponseOfString | null> {
        let url_ = this.baseUrl + "/api/technician/GetIdToken?";
        if (authToken === undefined)
            throw new Error("The parameter 'authToken' must be defined.");
        else if(authToken !== null)
            url_ += "authToken=" + encodeURIComponent("" + authToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIdToken(_response);
        });
    }

    protected processGetIdToken(response: Response): Promise<StatusValueResponseOfString | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResponseOfString.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusValueResponseOfString | null>(null as any);
    }
}

export class PartnerRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Creates the specified partner.
     * @param createPartner The create partner.
     * @return The id of the created partner.
     */
    create(createPartner: CreatePartner | null): Promise<StatusValueResponseOfInteger | null> {
        let url_ = this.baseUrl + "/api/partner/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPartner);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<StatusValueResponseOfInteger | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResponseOfInteger.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusValueResponseOfInteger | null>(null as any);
    }

    /**
     * Gets the partner.
     * @param id The identifier.
     * @return The partner.
     */
    getPartner(id: number): Promise<Partner | null> {
        let url_ = this.baseUrl + "/api/partner/GetPartner/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartner(_response);
        });
    }

    protected processGetPartner(response: Response): Promise<Partner | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Partner.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Partner | null>(null as any);
    }

    /**
     * Gets the partners matching the search parameters.
     * @param searchParams The search parameters.
     * @return The partners matching the search parameters.
     */
    getPartners(searchParams: PartnerPaginatedSearchParams | null): Promise<PartnerLight[] | null> {
        let url_ = this.baseUrl + "/api/partner/GetPartners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartners(_response);
        });
    }

    protected processGetPartners(response: Response): Promise<PartnerLight[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartnerLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerLight[] | null>(null as any);
    }

    /**
     * Gets the partners as select items.
     * @param searchParams The search parameters.
     * @return The partners as select items.
     */
    getPartnersAsSelectItems(searchParams: PartnerSearchParams | null): Promise<SelectItemOfInteger[] | null> {
        let url_ = this.baseUrl + "/api/partner/GetPartnersAsSelectItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartnersAsSelectItems(_response);
        });
    }

    protected processGetPartnersAsSelectItems(response: Response): Promise<SelectItemOfInteger[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItemOfInteger.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItemOfInteger[] | null>(null as any);
    }

    /**
     * Updates the specified partner.
     * @param updatePartner The update partner.
     */
    update(updatePartner: UpdatePartner | null): Promise<void> {
        let url_ = this.baseUrl + "/api/partner/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePartner);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CabinetRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Creates the specified cabinet.
     * @param createCabinet The create cabinet.
     * @return The id of the created cabinet.
     */
    create(createCabinet: CreateCabinet | null): Promise<StatusValueResponseOfInteger | null> {
        let url_ = this.baseUrl + "/api/cabinet/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createCabinet);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<StatusValueResponseOfInteger | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResponseOfInteger.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusValueResponseOfInteger | null>(null as any);
    }

    /**
     * Gets the cabinet.
     * @param id The identifier.
     * @return The cabinet.
     */
    getCabinet(id: number): Promise<Cabinet | null> {
        let url_ = this.baseUrl + "/api/cabinet/GetCabinet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCabinet(_response);
        });
    }

    protected processGetCabinet(response: Response): Promise<Cabinet | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Cabinet.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Cabinet | null>(null as any);
    }

    /**
     * Gets the cabinets matching the search parameters.
     * @param searchParams The search parameters.
     * @return The cabinets matching the search parameters.
     */
    getCabinets(searchParams: CabinetPaginatedSearchParams | null): Promise<CabinetLight[] | null> {
        let url_ = this.baseUrl + "/api/cabinet/GetCabinets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCabinets(_response);
        });
    }

    protected processGetCabinets(response: Response): Promise<CabinetLight[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CabinetLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CabinetLight[] | null>(null as any);
    }

    /**
     * Gets the cabinets in error.
     * @param searchParams The search parameters.
     * @return The cabinets in error.
     */
    getCabinetsInError(searchParams: CabinetPaginatedSearchParams | null): Promise<Cabinet[] | null> {
        let url_ = this.baseUrl + "/api/cabinet/GetCabinetsInError";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCabinetsInError(_response);
        });
    }

    protected processGetCabinetsInError(response: Response): Promise<Cabinet[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Cabinet.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Cabinet[] | null>(null as any);
    }

    /**
     * Gets the cabinets in error count.
     * @return The cabinet in error's count.
     */
    getCabinetsInErrorCount(): Promise<number> {
        let url_ = this.baseUrl + "/api/cabinet/GetCabinetsInErrorCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCabinetsInErrorCount(_response);
        });
    }

    protected processGetCabinetsInErrorCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Gets the cabinets export file.
     * @return The CSV file.
     */
    getCabinetsExportFile(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/cabinet/GetCabinetsExportFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCabinetsExportFile(_response);
        });
    }

    protected processGetCabinetsExportFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Gets the cabinets as select items.
     * @param searchParams The search parameters.
     * @return The cabinets as select items.
     */
    getCabinetsAsSelectItems(searchParams: CabinetSearchParams | null): Promise<SelectItemOfInteger[] | null> {
        let url_ = this.baseUrl + "/api/cabinet/GetCabinetsAsSelectItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCabinetsAsSelectItems(_response);
        });
    }

    protected processGetCabinetsAsSelectItems(response: Response): Promise<SelectItemOfInteger[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItemOfInteger.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItemOfInteger[] | null>(null as any);
    }

    /**
     * Gets the cabinet state and alarms.
     * @param id The identifier.
     * @return The state and alarms of the wanted cabinet.
     */
    getCabinetStateAndAlarms(id: number): Promise<CabinetStateAndAlarms | null> {
        let url_ = this.baseUrl + "/api/cabinet/GetCabinetStateAndAlarms?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCabinetStateAndAlarms(_response);
        });
    }

    protected processGetCabinetStateAndAlarms(response: Response): Promise<CabinetStateAndAlarms | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CabinetStateAndAlarms.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CabinetStateAndAlarms | null>(null as any);
    }

    /**
     * Imports the specified cabinet import.
     * @param cabinetImport The cabinet import.
     * @return The import errors, empty if success.
     */
    import(cabinetImport: CabinetImport | null): Promise<CabinetImportError[] | null> {
        let url_ = this.baseUrl + "/api/cabinet/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cabinetImport);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: Response): Promise<CabinetImportError[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CabinetImportError.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CabinetImportError[] | null>(null as any);
    }

    /**
     * Pushes the data.
     * @param externalDeviceResponse The externalDeviceResponse.
     * @return The response.
     */
    pushDataLora(externalDeviceResponse: BaseExternalDeviceResponse | null): Promise<PushDataResponse | null> {
        let url_ = this.baseUrl + "/api/cabinet/PushDataLora";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(externalDeviceResponse);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushDataLora(_response);
        });
    }

    protected processPushDataLora(response: Response): Promise<PushDataResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PushDataResponse.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PushDataResponse | null>(null as any);
    }

    /**
     * Pushes the data.
     * @param e The e.
     * @return The response.
     */
    pushDataLtem(e: string | null): Promise<PushDataResponse | null> {
        let url_ = this.baseUrl + "/api/cabinet/PushDataLtem?";
        if (e === undefined)
            throw new Error("The parameter 'e' must be defined.");
        else if(e !== null)
            url_ += "e=" + encodeURIComponent("" + e) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushDataLtem(_response);
        });
    }

    protected processPushDataLtem(response: Response): Promise<PushDataResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PushDataResponse.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PushDataResponse | null>(null as any);
    }

    /**
     * Open Cabinet With Name.
     * @param request The request.
     * @return The response.
     */
    openCabinetWithName(request: OpenCabinetWithNameRequest | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/cabinet/OpenCabinetWithName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOpenCabinetWithName(_response);
        });
    }

    protected processOpenCabinetWithName(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Open Cabinet With qrCodeByte.
     * @param request The request.
     * @return The response.
     */
    openCabinetWithQrCode(request: OpenCabinetWithQrCodeRequest | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/cabinet/OpenCabinetWithQrCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOpenCabinetWithQrCode(_response);
        });
    }

    protected processOpenCabinetWithQrCode(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Updates the specified cabinet.
     * @param updateCabinet The update cabinet.
     * @return The response status.
     */
    update(updateCabinet: UpdateCabinet | null): Promise<ResponseStatus> {
        let url_ = this.baseUrl + "/api/cabinet/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateCabinet);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ResponseStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseStatus>(null as any);
    }

    /**
     * Updates the pictures asynchronous.
     * @param cabinetId The cabinet identifier.
     * @param files (optional) The files.
     * @return The response status.
     */
    updatePictures(cabinetId: number, files: FileParameter[] | null | undefined): Promise<ResponseStatus> {
        let url_ = this.baseUrl + "/api/cabinet/UpdatePictures/{cabinetId}";
        if (cabinetId === undefined || cabinetId === null)
            throw new Error("The parameter 'cabinetId' must be defined.");
        url_ = url_.replace("{cabinetId}", encodeURIComponent("" + cabinetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePictures(_response);
        });
    }

    protected processUpdatePictures(response: Response): Promise<ResponseStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseStatus>(null as any);
    }

    /**
     * Deletes the picture asynchronous.
     * @param cabinetId The cabinet identifier.
     * @param path The path.
     * @return The response status.
     */
    deletePicture(cabinetId: number, path: string | null): Promise<ResponseStatus> {
        let url_ = this.baseUrl + "/api/cabinet/DeletePicture?";
        if (cabinetId === undefined || cabinetId === null)
            throw new Error("The parameter 'cabinetId' must be defined and cannot be null.");
        else
            url_ += "cabinetId=" + encodeURIComponent("" + cabinetId) + "&";
        if (path === undefined)
            throw new Error("The parameter 'path' must be defined.");
        else if(path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePicture(_response);
        });
    }

    protected processDeletePicture(response: Response): Promise<ResponseStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseStatus>(null as any);
    }

    /**
     * Get the QrCode img.
     * @param imeiNumber The imeiNumber.
     * @return The img of the qrCode in byte array.
     */
    getQrCodeImg(imeiNumber: string | null): Promise<StatusValueResponseOfByteOf | null> {
        let url_ = this.baseUrl + "/api/cabinet/GetQrCodeImg?";
        if (imeiNumber === undefined)
            throw new Error("The parameter 'imeiNumber' must be defined.");
        else if(imeiNumber !== null)
            url_ += "imeiNumber=" + encodeURIComponent("" + imeiNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQrCodeImg(_response);
        });
    }

    protected processGetQrCodeImg(response: Response): Promise<StatusValueResponseOfByteOf | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResponseOfByteOf.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusValueResponseOfByteOf | null>(null as any);
    }

    /**
     * Get the QrCode in a pdf Format.
     * @param imeiNumber The imeiNumber.
     * @return The tab of byte of the Pdf.
     */
    getQrCodeToPdf(imeiNumber: string | null): Promise<StatusValueResponseOfByteOf | null> {
        let url_ = this.baseUrl + "/api/cabinet/GetQrCodeToPdf?";
        if (imeiNumber === undefined)
            throw new Error("The parameter 'imeiNumber' must be defined.");
        else if(imeiNumber !== null)
            url_ += "imeiNumber=" + encodeURIComponent("" + imeiNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQrCodeToPdf(_response);
        });
    }

    protected processGetQrCodeToPdf(response: Response): Promise<StatusValueResponseOfByteOf | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResponseOfByteOf.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusValueResponseOfByteOf | null>(null as any);
    }
}

export class OperatorRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Creates the specified operator.
     * @param createOperator The create operator.
     * @return The id of the created operator.
     */
    create(createOperator: CreateOperator | null): Promise<StatusValueResponseOfInteger | null> {
        let url_ = this.baseUrl + "/api/operator/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createOperator);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<StatusValueResponseOfInteger | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResponseOfInteger.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusValueResponseOfInteger | null>(null as any);
    }

    /**
     * Gets the operator.
     * @param id The identifier.
     * @return The operator.
     */
    getOperator(id: number): Promise<Operator | null> {
        let url_ = this.baseUrl + "/api/operator/GetOperator/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOperator(_response);
        });
    }

    protected processGetOperator(response: Response): Promise<Operator | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Operator.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Operator | null>(null as any);
    }

    /**
     * Gets the operator matching the search parameters.
     * @param searchParams The search parameters.
     * @return The operators matching the search parameters.
     */
    getOperators(searchParams: OperatorPaginatedSearchParams | null): Promise<OperatorLight[] | null> {
        let url_ = this.baseUrl + "/api/operator/GetOperators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOperators(_response);
        });
    }

    protected processGetOperators(response: Response): Promise<OperatorLight[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OperatorLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OperatorLight[] | null>(null as any);
    }

    /**
     * Gets the operators as select items.
     * @param searchParams The search parameters.
     * @return The operators as select items.
     */
    getOperatorsAsSelectItems(searchParams: OperatorSearchParams | null): Promise<SelectItemOfInteger[] | null> {
        let url_ = this.baseUrl + "/api/operator/GetOperatorsAsSelectItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOperatorsAsSelectItems(_response);
        });
    }

    protected processGetOperatorsAsSelectItems(response: Response): Promise<SelectItemOfInteger[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItemOfInteger.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItemOfInteger[] | null>(null as any);
    }

    /**
     * Updates the specified operator.
     * @param updateOperator The update operator.
     * @return The status of update.
     */
    update(updateOperator: UpdateOperator | null): Promise<ResponseStatus> {
        let url_ = this.baseUrl + "/api/operator/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateOperator);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ResponseStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseStatus>(null as any);
    }

    /**
     * Removes the partner.
     * @param operatorId The operator identifier.
     * @param partnerId The partner identifier.
     */
    removePartner(operatorId: number, partnerId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/operator/RemovePartner?";
        if (operatorId === undefined || operatorId === null)
            throw new Error("The parameter 'operatorId' must be defined and cannot be null.");
        else
            url_ += "operatorId=" + encodeURIComponent("" + operatorId) + "&";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined and cannot be null.");
        else
            url_ += "partnerId=" + encodeURIComponent("" + partnerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemovePartner(_response);
        });
    }

    protected processRemovePartner(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AccountRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Logins.
     * @param loginRequest The login request.
     * @return True of logged in, false if not.
     */
    login(loginRequest: LoginRequest | null): Promise<boolean> {
        let url_ = this.baseUrl + "/api/account/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Logouts the current member.
     */
    logout(): Promise<void> {
        let url_ = this.baseUrl + "/api/account/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Asks the new password.
     * @param askNewPasswordRequest The ask new password request.
     */
    askNewPassword(askNewPasswordRequest: AskNewPasswordRequest | null): Promise<void> {
        let url_ = this.baseUrl + "/api/account/AskNewPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(askNewPasswordRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAskNewPassword(_response);
        });
    }

    protected processAskNewPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Resets the password.
     * @param resetPasswordRequest The reset password request.
     */
    resetPassword(resetPasswordRequest: ResetPasswordRequest | null): Promise<void> {
        let url_ = this.baseUrl + "/api/account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPasswordRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the current member.
     * @return The current member.
     */
    getCurrentMember(): Promise<CurrentMember | null> {
        let url_ = this.baseUrl + "/api/account/GetCurrentMember";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentMember(_response);
        });
    }

    protected processGetCurrentMember(response: Response): Promise<CurrentMember | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentMember.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentMember | null>(null as any);
    }
}

export class UtilityRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the cities as select item.
     * @param query The query.
     * @return The cities as select items.
     */
    getCitiesAsSelectItem(query: string | null): Promise<SelectItemOfInteger[] | null> {
        let url_ = this.baseUrl + "/api/utility/GetCitiesAsSelectItem?";
        if (query === undefined)
            throw new Error("The parameter 'query' must be defined.");
        else if(query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCitiesAsSelectItem(_response);
        });
    }

    protected processGetCitiesAsSelectItem(response: Response): Promise<SelectItemOfInteger[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItemOfInteger.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItemOfInteger[] | null>(null as any);
    }
}

/** Contains the definition of an object of type StatusValueResponse`1. */
export class StatusValueResponseOfInteger implements IStatusValueResponseOfInteger {
    /** Gets or sets the status. */
    status!: ResponseStatus;
    /** Gets or sets the value. */
    value!: number;

    constructor(data?: IStatusValueResponseOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StatusValueResponseOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new StatusValueResponseOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["value"] = this.value;
        return data;
    }
}

/** Contains the definition of an object of type StatusValueResponse`1. */
export interface IStatusValueResponseOfInteger {
    /** Gets or sets the status. */
    status: ResponseStatus;
    /** Gets or sets the value. */
    value: number;
}

/** Contains the definition of ResponseStatus. */
export enum ResponseStatus {
    Unknown = 0,
    Success = 1,
    NameNotAvailable = 2,
    EmailNotAvailable = 3,
    ExistingAccountForOtherOperator = 4,
    ImeiNumberNotAvailable = 5,
    TechnicianAlreadyHasOngoingInterventionOnThatCabinet = 6,
    PromNotAvailable = 7,
    PhoneNumberNotAvailable = 8,
    CabinetAlreadyCreatedInExternalDevice = 9,
    TheCabinetHaveNoQrCode = 10,
    TokenIsNotValid = 11,
}

/** Contains the definition of an object of type BaseEditMember. */
export abstract class BaseEditMember implements IBaseEditMember {
    /** Gets or sets the email. */
    email!: string;
    /** Gets or sets the first name. */
    firstName!: string;
    /** Gets or sets the last name. */
    lastName!: string;
    /** Gets or sets a value indicating whether this member is intervener. */
    isIntervener!: boolean;
    /** Gets or sets a value indicating whether this instance is supervisor. */
    isSupervisor!: boolean;
    /** Gets or sets a value indicating whether this instance is alarmist. */
    isAlarmist!: boolean;
    /** Gets or sets the phone number. */
    phoneNumber?: string | undefined;

    constructor(data?: IBaseEditMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isIntervener = _data["isIntervener"];
            this.isSupervisor = _data["isSupervisor"];
            this.isAlarmist = _data["isAlarmist"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): BaseEditMember {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEditMember' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isIntervener"] = this.isIntervener;
        data["isSupervisor"] = this.isSupervisor;
        data["isAlarmist"] = this.isAlarmist;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

/** Contains the definition of an object of type BaseEditMember. */
export interface IBaseEditMember {
    /** Gets or sets the email. */
    email: string;
    /** Gets or sets the first name. */
    firstName: string;
    /** Gets or sets the last name. */
    lastName: string;
    /** Gets or sets a value indicating whether this member is intervener. */
    isIntervener: boolean;
    /** Gets or sets a value indicating whether this instance is supervisor. */
    isSupervisor: boolean;
    /** Gets or sets a value indicating whether this instance is alarmist. */
    isAlarmist: boolean;
    /** Gets or sets the phone number. */
    phoneNumber?: string | undefined;
}

/** Contains the definition of an object of type CreateMember. */
export class CreateMember extends BaseEditMember implements ICreateMember {
    /** Gets or sets the managed operator identifier. */
    managedOperatorId!: number;

    constructor(data?: ICreateMember) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.managedOperatorId = _data["managedOperatorId"];
        }
    }

    static fromJS(data: any): CreateMember {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managedOperatorId"] = this.managedOperatorId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateMember. */
export interface ICreateMember extends IBaseEditMember {
    /** Gets or sets the managed operator identifier. */
    managedOperatorId: number;
}

/** Contains the definition of an object of type MemberLight. */
export class MemberLight implements IMemberLight {
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the groups. */
    groups?: string[] | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the phone number. */
    phoneNumber?: string | undefined;

    constructor(data?: IMemberLight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
            this.id = _data["id"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): MemberLight {
        data = typeof data === 'object' ? data : {};
        let result = new MemberLight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["id"] = this.id;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

/** Contains the definition of an object of type MemberLight. */
export interface IMemberLight {
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the groups. */
    groups?: string[] | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the phone number. */
    phoneNumber?: string | undefined;
}

/** Contains the definition of an object of type Member. */
export class Member extends MemberLight implements IMember {

    constructor(data?: IMember) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): Member {
        data = typeof data === 'object' ? data : {};
        let result = new Member();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type Member. */
export interface IMember extends IMemberLight {
}

/** Contains the definition of an object of type MemberPaginatedSearchParams. */
export class MemberPaginatedSearchParams implements IMemberPaginatedSearchParams {
    /** Gets or sets the operator identifier. */
    operatorId?: number | undefined;
    /** Gets or sets the page. 0 is the first page. */
    page!: number;
    /** Gets or sets the size of the page. */
    pageSize!: number;

    constructor(data?: IMemberPaginatedSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatorId = _data["operatorId"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): MemberPaginatedSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new MemberPaginatedSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatorId"] = this.operatorId;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

/** Contains the definition of an object of type MemberPaginatedSearchParams. */
export interface IMemberPaginatedSearchParams {
    /** Gets or sets the operator identifier. */
    operatorId?: number | undefined;
    /** Gets or sets the page. 0 is the first page. */
    page: number;
    /** Gets or sets the size of the page. */
    pageSize: number;
}

/** Contains the definition of an object of type UpdateMember. */
export class UpdateMember extends BaseEditMember implements IUpdateMember {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdateMember) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateMember {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateMember. */
export interface IUpdateMember extends IBaseEditMember {
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type BaseEditIntervention. */
export abstract class BaseEditIntervention implements IBaseEditIntervention {
    /** Gets or sets the in charge operator identifier. */
    inChargeOperatorId!: number;
    /** Gets or sets the partner id. */
    partnerId?: number | undefined;
    /** Gets or sets the technician identifier. */
    technicianId?: number | undefined;

    constructor(data?: IBaseEditIntervention) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inChargeOperatorId = _data["inChargeOperatorId"];
            this.partnerId = _data["partnerId"];
            this.technicianId = _data["technicianId"];
        }
    }

    static fromJS(data: any): BaseEditIntervention {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEditIntervention' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inChargeOperatorId"] = this.inChargeOperatorId;
        data["partnerId"] = this.partnerId;
        data["technicianId"] = this.technicianId;
        return data;
    }
}

/** Contains the definition of an object of type BaseEditIntervention. */
export interface IBaseEditIntervention {
    /** Gets or sets the in charge operator identifier. */
    inChargeOperatorId: number;
    /** Gets or sets the partner id. */
    partnerId?: number | undefined;
    /** Gets or sets the technician identifier. */
    technicianId?: number | undefined;
}

/** Contains the definition of an object of type CreateIntervention. */
export class CreateIntervention extends BaseEditIntervention implements ICreateIntervention {
    /** Gets or sets the cabinet identifier. */
    cabinetId!: number;
    /** Gets or sets the infrastructure operator identifier. */
    infrastructureOperatorId!: number;
    /** Gets or sets a value indicating whether this instance is ongoing intervention. */
    isOngoingIntervention!: boolean;
    /** Gets or sets a value indicating whether this instance is for manual opening. */
    isForManualOpening!: boolean;
    /** Gets or sets the name. */
    name!: string;
    /** Gets or sets the planned start date. */
    plannedStartDate!: Date;

    constructor(data?: ICreateIntervention) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cabinetId = _data["cabinetId"];
            this.infrastructureOperatorId = _data["infrastructureOperatorId"];
            this.isOngoingIntervention = _data["isOngoingIntervention"];
            this.isForManualOpening = _data["isForManualOpening"];
            this.name = _data["name"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateIntervention {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIntervention();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinetId"] = this.cabinetId;
        data["infrastructureOperatorId"] = this.infrastructureOperatorId;
        data["isOngoingIntervention"] = this.isOngoingIntervention;
        data["isForManualOpening"] = this.isForManualOpening;
        data["name"] = this.name;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateIntervention. */
export interface ICreateIntervention extends IBaseEditIntervention {
    /** Gets or sets the cabinet identifier. */
    cabinetId: number;
    /** Gets or sets the infrastructure operator identifier. */
    infrastructureOperatorId: number;
    /** Gets or sets a value indicating whether this instance is ongoing intervention. */
    isOngoingIntervention: boolean;
    /** Gets or sets a value indicating whether this instance is for manual opening. */
    isForManualOpening: boolean;
    /** Gets or sets the name. */
    name: string;
    /** Gets or sets the planned start date. */
    plannedStartDate: Date;
}

/** Contains the definition of an object of type Intervention. */
export class Intervention implements IIntervention {
    /** Gets or sets the cabinet. */
    cabinet?: CabinetLight | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the in charge operator. */
    inChargeOperator?: OperatorLight | undefined;
    /** Gets or sets the infrastructure operator. */
    infrastructureOperator?: OperatorLight | undefined;
    /** Gets or sets a value indicating whether this instance is ongoing intervention. */
    isOngoingIntervention!: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the partner. */
    partner?: PartnerLight | undefined;
    /** Gets or sets the planned start date. */
    plannedStartDate?: Date | undefined;
    /** Gets or sets the state. */
    state!: InterventionState;
    /** Gets or sets the technician. */
    technician?: TechnicianLight | undefined;

    constructor(data?: IIntervention) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cabinet = _data["cabinet"] ? CabinetLight.fromJS(_data["cabinet"]) : <any>undefined;
            this.id = _data["id"];
            this.inChargeOperator = _data["inChargeOperator"] ? OperatorLight.fromJS(_data["inChargeOperator"]) : <any>undefined;
            this.infrastructureOperator = _data["infrastructureOperator"] ? OperatorLight.fromJS(_data["infrastructureOperator"]) : <any>undefined;
            this.isOngoingIntervention = _data["isOngoingIntervention"];
            this.name = _data["name"];
            this.partner = _data["partner"] ? PartnerLight.fromJS(_data["partner"]) : <any>undefined;
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.technician = _data["technician"] ? TechnicianLight.fromJS(_data["technician"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Intervention {
        data = typeof data === 'object' ? data : {};
        let result = new Intervention();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinet"] = this.cabinet ? this.cabinet.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["inChargeOperator"] = this.inChargeOperator ? this.inChargeOperator.toJSON() : <any>undefined;
        data["infrastructureOperator"] = this.infrastructureOperator ? this.infrastructureOperator.toJSON() : <any>undefined;
        data["isOngoingIntervention"] = this.isOngoingIntervention;
        data["name"] = this.name;
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["technician"] = this.technician ? this.technician.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type Intervention. */
export interface IIntervention {
    /** Gets or sets the cabinet. */
    cabinet?: CabinetLight | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the in charge operator. */
    inChargeOperator?: OperatorLight | undefined;
    /** Gets or sets the infrastructure operator. */
    infrastructureOperator?: OperatorLight | undefined;
    /** Gets or sets a value indicating whether this instance is ongoing intervention. */
    isOngoingIntervention: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the partner. */
    partner?: PartnerLight | undefined;
    /** Gets or sets the planned start date. */
    plannedStartDate?: Date | undefined;
    /** Gets or sets the state. */
    state: InterventionState;
    /** Gets or sets the technician. */
    technician?: TechnicianLight | undefined;
}

/** Contains the definition of an object of type CabinetLight. */
export class CabinetLight implements ICabinetLight {
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets a value indicating whether this instance has alarms. */
    hasAlarms!: boolean;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name of the infrastructure operator. */
    infrastructureOperatorName?: string | undefined;
    /** Gets or sets a value indicating whether this instance is imei missing. */
    isImeiMissing!: boolean;
    /** Gets or sets the latitude. */
    latitude?: number | undefined;
    /** Gets or sets the longitude. */
    longitude?: number | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the prom. */
    prom?: number | undefined;
    /** Gets or sets the state. */
    state!: CabinetState;

    constructor(data?: ICabinetLight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.hasAlarms = _data["hasAlarms"];
            this.id = _data["id"];
            this.infrastructureOperatorName = _data["infrastructureOperatorName"];
            this.isImeiMissing = _data["isImeiMissing"];
            this.latitude = _data["latitude"];
            this.longitude = _data["Longitude"];
            this.name = _data["name"];
            this.postalCode = _data["postalCode"];
            this.prom = _data["prom"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): CabinetLight {
        data = typeof data === 'object' ? data : {};
        let result = new CabinetLight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["hasAlarms"] = this.hasAlarms;
        data["id"] = this.id;
        data["infrastructureOperatorName"] = this.infrastructureOperatorName;
        data["isImeiMissing"] = this.isImeiMissing;
        data["latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["name"] = this.name;
        data["postalCode"] = this.postalCode;
        data["prom"] = this.prom;
        data["state"] = this.state;
        return data;
    }
}

/** Contains the definition of an object of type CabinetLight. */
export interface ICabinetLight {
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets a value indicating whether this instance has alarms. */
    hasAlarms: boolean;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name of the infrastructure operator. */
    infrastructureOperatorName?: string | undefined;
    /** Gets or sets a value indicating whether this instance is imei missing. */
    isImeiMissing: boolean;
    /** Gets or sets the latitude. */
    latitude?: number | undefined;
    /** Gets or sets the longitude. */
    longitude?: number | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the prom. */
    prom?: number | undefined;
    /** Gets or sets the state. */
    state: CabinetState;
}

/** Contains the definition of CabinetState. */
export enum CabinetState {
    Unknown = 0,
    Closed = 1,
    Open = 2,
}

/** Contains the definition of an object of type OperatorLight. */
export class OperatorLight implements IOperatorLight {
    /** Gets or sets a value indicating whether this instance can create cabinet. */
    canAddOrEditCabinet!: boolean;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the phone. */
    phone?: string | undefined;
    /** Gets or sets the prefix for technicians. */
    prefixForTechnicians?: string | undefined;

    constructor(data?: IOperatorLight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAddOrEditCabinet = _data["canAddOrEditCabinet"];
            this.email = _data["email"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.prefixForTechnicians = _data["prefixForTechnicians"];
        }
    }

    static fromJS(data: any): OperatorLight {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorLight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAddOrEditCabinet"] = this.canAddOrEditCabinet;
        data["email"] = this.email;
        data["id"] = this.id;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["prefixForTechnicians"] = this.prefixForTechnicians;
        return data;
    }
}

/** Contains the definition of an object of type OperatorLight. */
export interface IOperatorLight {
    /** Gets or sets a value indicating whether this instance can create cabinet. */
    canAddOrEditCabinet: boolean;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the phone. */
    phone?: string | undefined;
    /** Gets or sets the prefix for technicians. */
    prefixForTechnicians?: string | undefined;
}

/** Contains the definition of an object of type PartnerLight. */
export class PartnerLight implements IPartnerLight {
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the phone. */
    phone?: string | undefined;

    constructor(data?: IPartnerLight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): PartnerLight {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerLight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["id"] = this.id;
        data["name"] = this.name;
        data["phone"] = this.phone;
        return data;
    }
}

/** Contains the definition of an object of type PartnerLight. */
export interface IPartnerLight {
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the phone. */
    phone?: string | undefined;
}

/** Contains the definition of InterventionState. */
export enum InterventionState {
    MissingInformation = 1,
    Planned = 2,
    InProgress = 3,
    Done = 4,
    Canceled = 5,
    Permanent = 6,
    Outdated = 7,
}

/** Contains the definition of an object of type TechnicianLight. */
export class TechnicianLight implements ITechnicianLight {
    /** Gets the groups. */
    groups?: string[] | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the manager email. */
    managerEmail?: string | undefined;
    /** Gets or sets the manager phone. */
    managerPhone?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the name of the partner. */
    partnerName?: string | undefined;
    /** Gets or sets the technician email. */
    technicianEmail?: string | undefined;
    /** Gets or sets the technician phone. */
    technicianPhone?: string | undefined;

    constructor(data?: ITechnicianLight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
            this.id = _data["id"];
            this.managerEmail = _data["managerEmail"];
            this.managerPhone = _data["managerPhone"];
            this.name = _data["name"];
            this.partnerName = _data["partnerName"];
            this.technicianEmail = _data["technicianEmail"];
            this.technicianPhone = _data["technicianPhone"];
        }
    }

    static fromJS(data: any): TechnicianLight {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicianLight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["id"] = this.id;
        data["managerEmail"] = this.managerEmail;
        data["managerPhone"] = this.managerPhone;
        data["name"] = this.name;
        data["partnerName"] = this.partnerName;
        data["technicianEmail"] = this.technicianEmail;
        data["technicianPhone"] = this.technicianPhone;
        return data;
    }
}

/** Contains the definition of an object of type TechnicianLight. */
export interface ITechnicianLight {
    /** Gets the groups. */
    groups?: string[] | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the manager email. */
    managerEmail?: string | undefined;
    /** Gets or sets the manager phone. */
    managerPhone?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the name of the partner. */
    partnerName?: string | undefined;
    /** Gets or sets the technician email. */
    technicianEmail?: string | undefined;
    /** Gets or sets the technician phone. */
    technicianPhone?: string | undefined;
}

/** Contains the definition of an object of type InterventionLight. */
export class InterventionLight implements IInterventionLight {
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the cabinet name. */
    cabinetName?: string | undefined;
    /** Gets or sets the type of the cabinet. */
    cabinetType!: CabinetType;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the closing date. */
    closingDate?: Date | undefined;
    /** Gets or sets the name of the in charge operator. */
    inChargeOperatorName?: string | undefined;
    /** Gets or sets a value indicating whether this instance is ongoing intervention. */
    isOngoingIntervention!: boolean;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the keys removal date. */
    keysRemovalDate?: Date | undefined;
    /** Gets or sets the keys returna date. */
    keysReturnalDate?: Date | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the opening date. */
    openingDate?: Date | undefined;
    /** Gets or sets the name of the partner. */
    partnerName?: string | undefined;
    /** Gets or sets the planned start date. */
    plannedStartDate?: Date | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the state. */
    state!: InterventionState;
    /** Gets or sets the name of the technician. */
    technicianName?: string | undefined;
    /** Gets or sets the technician phone. */
    technicianPhone?: string | undefined;
    /** Gets or sets the contacts count. */
    contactsCount!: number;

    constructor(data?: IInterventionLight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.cabinetName = _data["cabinetName"];
            this.cabinetType = _data["cabinetType"];
            this.city = _data["city"];
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : <any>undefined;
            this.inChargeOperatorName = _data["inChargeOperatorName"];
            this.isOngoingIntervention = _data["isOngoingIntervention"];
            this.id = _data["id"];
            this.keysRemovalDate = _data["keysRemovalDate"] ? new Date(_data["keysRemovalDate"].toString()) : <any>undefined;
            this.keysReturnalDate = _data["keysReturnalDate"] ? new Date(_data["keysReturnalDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.openingDate = _data["openingDate"] ? new Date(_data["openingDate"].toString()) : <any>undefined;
            this.partnerName = _data["partnerName"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : <any>undefined;
            this.postalCode = _data["postalCode"];
            this.state = _data["state"];
            this.technicianName = _data["technicianName"];
            this.technicianPhone = _data["technicianPhone"];
            this.contactsCount = _data["contactsCount"];
        }
    }

    static fromJS(data: any): InterventionLight {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionLight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["cabinetName"] = this.cabinetName;
        data["cabinetType"] = this.cabinetType;
        data["city"] = this.city;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        data["inChargeOperatorName"] = this.inChargeOperatorName;
        data["isOngoingIntervention"] = this.isOngoingIntervention;
        data["id"] = this.id;
        data["keysRemovalDate"] = this.keysRemovalDate ? this.keysRemovalDate.toISOString() : <any>undefined;
        data["keysReturnalDate"] = this.keysReturnalDate ? this.keysReturnalDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["openingDate"] = this.openingDate ? this.openingDate.toISOString() : <any>undefined;
        data["partnerName"] = this.partnerName;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : <any>undefined;
        data["postalCode"] = this.postalCode;
        data["state"] = this.state;
        data["technicianName"] = this.technicianName;
        data["technicianPhone"] = this.technicianPhone;
        data["contactsCount"] = this.contactsCount;
        return data;
    }
}

/** Contains the definition of an object of type InterventionLight. */
export interface IInterventionLight {
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the cabinet name. */
    cabinetName?: string | undefined;
    /** Gets or sets the type of the cabinet. */
    cabinetType: CabinetType;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the closing date. */
    closingDate?: Date | undefined;
    /** Gets or sets the name of the in charge operator. */
    inChargeOperatorName?: string | undefined;
    /** Gets or sets a value indicating whether this instance is ongoing intervention. */
    isOngoingIntervention: boolean;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the keys removal date. */
    keysRemovalDate?: Date | undefined;
    /** Gets or sets the keys returna date. */
    keysReturnalDate?: Date | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the opening date. */
    openingDate?: Date | undefined;
    /** Gets or sets the name of the partner. */
    partnerName?: string | undefined;
    /** Gets or sets the planned start date. */
    plannedStartDate?: Date | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the state. */
    state: InterventionState;
    /** Gets or sets the name of the technician. */
    technicianName?: string | undefined;
    /** Gets or sets the technician phone. */
    technicianPhone?: string | undefined;
    /** Gets or sets the contacts count. */
    contactsCount: number;
}

/** Contains the definition of AlarmType. */
export enum CabinetType {
    Unknown = 0,
    DefaultCabinet = 1,
    KeysCabinet = 2,
}

/** Contains the definition of an object of type InterventionSearchParams. */
export class InterventionSearchParams implements IInterventionSearchParams {
    /** Gets or sets the cabinet identifier. */
    cabinetId?: number | undefined;
    /** Gets or sets the name of the cabinet. */
    cabinetName?: string | undefined;
    /** Gets or sets the date. */
    date?: Date | undefined;
    /** Gets or sets the in charge operator ids. */
    inChargeOperatorIds?: number[] | undefined;
    /** Gets or sets the infrastructure operator ids. */
    infrastructureOperatorIds?: number[] | undefined;
    /** Gets or sets the operator identifiers. */
    operatorIds?: number[] | undefined;
    /** Gets or sets the name of the partner. */
    partnerName?: string | undefined;
    /** Gets or sets the technician identifier. */
    technicianId?: number | undefined;

    constructor(data?: IInterventionSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cabinetId = _data["cabinetId"];
            this.cabinetName = _data["cabinetName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["inChargeOperatorIds"])) {
                this.inChargeOperatorIds = [] as any;
                for (let item of _data["inChargeOperatorIds"])
                    this.inChargeOperatorIds!.push(item);
            }
            if (Array.isArray(_data["infrastructureOperatorIds"])) {
                this.infrastructureOperatorIds = [] as any;
                for (let item of _data["infrastructureOperatorIds"])
                    this.infrastructureOperatorIds!.push(item);
            }
            if (Array.isArray(_data["operatorIds"])) {
                this.operatorIds = [] as any;
                for (let item of _data["operatorIds"])
                    this.operatorIds!.push(item);
            }
            this.partnerName = _data["partnerName"];
            this.technicianId = _data["technicianId"];
        }
    }

    static fromJS(data: any): InterventionSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinetId"] = this.cabinetId;
        data["cabinetName"] = this.cabinetName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.inChargeOperatorIds)) {
            data["inChargeOperatorIds"] = [];
            for (let item of this.inChargeOperatorIds)
                data["inChargeOperatorIds"].push(item);
        }
        if (Array.isArray(this.infrastructureOperatorIds)) {
            data["infrastructureOperatorIds"] = [];
            for (let item of this.infrastructureOperatorIds)
                data["infrastructureOperatorIds"].push(item);
        }
        if (Array.isArray(this.operatorIds)) {
            data["operatorIds"] = [];
            for (let item of this.operatorIds)
                data["operatorIds"].push(item);
        }
        data["partnerName"] = this.partnerName;
        data["technicianId"] = this.technicianId;
        return data;
    }
}

/** Contains the definition of an object of type InterventionSearchParams. */
export interface IInterventionSearchParams {
    /** Gets or sets the cabinet identifier. */
    cabinetId?: number | undefined;
    /** Gets or sets the name of the cabinet. */
    cabinetName?: string | undefined;
    /** Gets or sets the date. */
    date?: Date | undefined;
    /** Gets or sets the in charge operator ids. */
    inChargeOperatorIds?: number[] | undefined;
    /** Gets or sets the infrastructure operator ids. */
    infrastructureOperatorIds?: number[] | undefined;
    /** Gets or sets the operator identifiers. */
    operatorIds?: number[] | undefined;
    /** Gets or sets the name of the partner. */
    partnerName?: string | undefined;
    /** Gets or sets the technician identifier. */
    technicianId?: number | undefined;
}

/** Contains the definition of an object of type InterventionPaginatedSearchParams. */
export class InterventionPaginatedSearchParams extends InterventionSearchParams implements IInterventionPaginatedSearchParams {
    /** Gets or sets the page. 0 is the first page. */
    page!: number;
    /** Gets or sets the size of the page. */
    pageSize!: number;

    constructor(data?: IInterventionPaginatedSearchParams) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): InterventionPaginatedSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionPaginatedSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type InterventionPaginatedSearchParams. */
export interface IInterventionPaginatedSearchParams extends IInterventionSearchParams {
    /** Gets or sets the page. 0 is the first page. */
    page: number;
    /** Gets or sets the size of the page. */
    pageSize: number;
}

/** Contains the definition of an object of type InterventionExportParams. */
export class InterventionExportParams implements IInterventionExportParams {
    /** Gets or sets the cabinet identifiers. */
    cabinetIds?: number[] | undefined;
    /** Gets or sets the planned start date. */
    startDate!: Date;
    /** Gets or sets the planned start date. */
    endDate!: Date;

    constructor(data?: IInterventionExportParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cabinetIds"])) {
                this.cabinetIds = [] as any;
                for (let item of _data["cabinetIds"])
                    this.cabinetIds!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InterventionExportParams {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionExportParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cabinetIds)) {
            data["cabinetIds"] = [];
            for (let item of this.cabinetIds)
                data["cabinetIds"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type InterventionExportParams. */
export interface IInterventionExportParams {
    /** Gets or sets the cabinet identifiers. */
    cabinetIds?: number[] | undefined;
    /** Gets or sets the planned start date. */
    startDate: Date;
    /** Gets or sets the planned start date. */
    endDate: Date;
}

/** Contains the definition of an object of type InterventionAndUnauthorizedOpeningWrapper. */
export class InterventionAndUnauthorizedOpeningWrapper implements IInterventionAndUnauthorizedOpeningWrapper {
    /** Gets or sets the cabinet name. */
    cabinetName?: string | undefined;
    /** Gets or sets the cabinet name. */
    cabinetType!: CabinetType;
    /** Gets or sets the closing date. */
    closingDate?: Date | undefined;
    /** Gets or sets the name of the in charge operator. */
    inChargeOperatorName?: string | undefined;
    /** Gets or sets the key removal date. */
    keysRemovalDate?: Date | undefined;
    /** Gets or sets the key returnal date. */
    keysReturnalDate?: Date | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the opening date. */
    openingDate?: Date | undefined;
    /** Gets or sets the name of the partner. */
    partnerName?: string | undefined;
    /** Gets or sets the planned start date. */
    plannedStartDate?: Date | undefined;
    /** Gets or sets the state. */
    state?: InterventionState | undefined;
    /** Gets or sets the name of the technician. */
    technicianName?: string | undefined;
    /** Gets or sets the technician phone. */
    technicianPhone?: string | undefined;
    /** Gets or sets the type. */
    type!: InterventionNonAuthorizedOpeningType;

    constructor(data?: IInterventionAndUnauthorizedOpeningWrapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cabinetName = _data["cabinetName"];
            this.cabinetType = _data["cabinetType"];
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : <any>undefined;
            this.inChargeOperatorName = _data["inChargeOperatorName"];
            this.keysRemovalDate = _data["keysRemovalDate"] ? new Date(_data["keysRemovalDate"].toString()) : <any>undefined;
            this.keysReturnalDate = _data["keysReturnalDate"] ? new Date(_data["keysReturnalDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.openingDate = _data["openingDate"] ? new Date(_data["openingDate"].toString()) : <any>undefined;
            this.partnerName = _data["partnerName"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.technicianName = _data["technicianName"];
            this.technicianPhone = _data["technicianPhone"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): InterventionAndUnauthorizedOpeningWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionAndUnauthorizedOpeningWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinetName"] = this.cabinetName;
        data["cabinetType"] = this.cabinetType;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        data["inChargeOperatorName"] = this.inChargeOperatorName;
        data["keysRemovalDate"] = this.keysRemovalDate ? this.keysRemovalDate.toISOString() : <any>undefined;
        data["keysReturnalDate"] = this.keysReturnalDate ? this.keysReturnalDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["openingDate"] = this.openingDate ? this.openingDate.toISOString() : <any>undefined;
        data["partnerName"] = this.partnerName;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["technicianName"] = this.technicianName;
        data["technicianPhone"] = this.technicianPhone;
        data["type"] = this.type;
        return data;
    }
}

/** Contains the definition of an object of type InterventionAndUnauthorizedOpeningWrapper. */
export interface IInterventionAndUnauthorizedOpeningWrapper {
    /** Gets or sets the cabinet name. */
    cabinetName?: string | undefined;
    /** Gets or sets the cabinet name. */
    cabinetType: CabinetType;
    /** Gets or sets the closing date. */
    closingDate?: Date | undefined;
    /** Gets or sets the name of the in charge operator. */
    inChargeOperatorName?: string | undefined;
    /** Gets or sets the key removal date. */
    keysRemovalDate?: Date | undefined;
    /** Gets or sets the key returnal date. */
    keysReturnalDate?: Date | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the opening date. */
    openingDate?: Date | undefined;
    /** Gets or sets the name of the partner. */
    partnerName?: string | undefined;
    /** Gets or sets the planned start date. */
    plannedStartDate?: Date | undefined;
    /** Gets or sets the state. */
    state?: InterventionState | undefined;
    /** Gets or sets the name of the technician. */
    technicianName?: string | undefined;
    /** Gets or sets the technician phone. */
    technicianPhone?: string | undefined;
    /** Gets or sets the type. */
    type: InterventionNonAuthorizedOpeningType;
}

/** Contains the definition of InterventionNonAuthorizedOpeningType. */
export enum InterventionNonAuthorizedOpeningType {
    Default = 0,
    NonAuthorizedOpening = 1,
    SuspiciousKeysRemoval = 2,
}

/** Contains the definition of an object of type InterventionPaginatedLiteSearchParams. */
export class InterventionPaginatedLiteSearchParams implements IInterventionPaginatedLiteSearchParams {
    /** Gets or sets the cabinet identifier. */
    cabinetId!: number;
    /** Gets or sets the page. 0 is the first page. */
    page!: number;
    /** Gets or sets the size of the page. */
    pageSize!: number;

    constructor(data?: IInterventionPaginatedLiteSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cabinetId = _data["cabinetId"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): InterventionPaginatedLiteSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new InterventionPaginatedLiteSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinetId"] = this.cabinetId;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

/** Contains the definition of an object of type InterventionPaginatedLiteSearchParams. */
export interface IInterventionPaginatedLiteSearchParams {
    /** Gets or sets the cabinet identifier. */
    cabinetId: number;
    /** Gets or sets the page. 0 is the first page. */
    page: number;
    /** Gets or sets the size of the page. */
    pageSize: number;
}

/** Contains the definition of an object of type UpdateIntervention. */
export class UpdateIntervention extends BaseEditIntervention implements IUpdateIntervention {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdateIntervention) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateIntervention {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIntervention();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateIntervention. */
export interface IUpdateIntervention extends IBaseEditIntervention {
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type Statistics. */
export class Statistics implements IStatistics {
    /** Gets or sets the daily openings. */
    dailyOpenings!: number;
    /** Gets or sets the daily cabinet openings. */
    dailyCabinetOpenings?: number | undefined;
    /** Gets or sets the daily operator openings. */
    dailyOperatorOpenings?: number | undefined;
    /** Gets or sets the registered technician count per commercial operator. */
    registeredTechnicianCount?: number | undefined;
    /** Gets or sets the average opening time. */
    averageOpeningTime!: number;

    constructor(data?: IStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyOpenings = _data["dailyOpenings"];
            this.dailyCabinetOpenings = _data["dailyCabinetOpenings"];
            this.dailyOperatorOpenings = _data["dailyOperatorOpenings"];
            this.registeredTechnicianCount = _data["registeredTechnicianCount"];
            this.averageOpeningTime = _data["averageOpeningTime"];
        }
    }

    static fromJS(data: any): Statistics {
        data = typeof data === 'object' ? data : {};
        let result = new Statistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyOpenings"] = this.dailyOpenings;
        data["dailyCabinetOpenings"] = this.dailyCabinetOpenings;
        data["dailyOperatorOpenings"] = this.dailyOperatorOpenings;
        data["registeredTechnicianCount"] = this.registeredTechnicianCount;
        data["averageOpeningTime"] = this.averageOpeningTime;
        return data;
    }
}

/** Contains the definition of an object of type Statistics. */
export interface IStatistics {
    /** Gets or sets the daily openings. */
    dailyOpenings: number;
    /** Gets or sets the daily cabinet openings. */
    dailyCabinetOpenings?: number | undefined;
    /** Gets or sets the daily operator openings. */
    dailyOperatorOpenings?: number | undefined;
    /** Gets or sets the registered technician count per commercial operator. */
    registeredTechnicianCount?: number | undefined;
    /** Gets or sets the average opening time. */
    averageOpeningTime: number;
}

/** Contains the definition of an object of type StatisticsSearchParams. */
export class StatisticsSearchParams implements IStatisticsSearchParams {
    /** Gets or sets the daily opening cabinet identifier. */
    dailyOpeningCabinetId?: number | undefined;
    /** Gets or sets the daily opening commercial operator identifier. */
    dailyOpeningCommercialOperatorId?: number | undefined;
    /** Gets or sets the technician commercial operator identifier. */
    technicianCommercialOperatorId?: number | undefined;

    constructor(data?: IStatisticsSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyOpeningCabinetId = _data["dailyOpeningCabinetId"];
            this.dailyOpeningCommercialOperatorId = _data["dailyOpeningCommercialOperatorId"];
            this.technicianCommercialOperatorId = _data["technicianCommercialOperatorId"];
        }
    }

    static fromJS(data: any): StatisticsSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyOpeningCabinetId"] = this.dailyOpeningCabinetId;
        data["dailyOpeningCommercialOperatorId"] = this.dailyOpeningCommercialOperatorId;
        data["technicianCommercialOperatorId"] = this.technicianCommercialOperatorId;
        return data;
    }
}

/** Contains the definition of an object of type StatisticsSearchParams. */
export interface IStatisticsSearchParams {
    /** Gets or sets the daily opening cabinet identifier. */
    dailyOpeningCabinetId?: number | undefined;
    /** Gets or sets the daily opening commercial operator identifier. */
    dailyOpeningCommercialOperatorId?: number | undefined;
    /** Gets or sets the technician commercial operator identifier. */
    technicianCommercialOperatorId?: number | undefined;
}

export abstract class TwilioRequest implements ITwilioRequest {
    accountSid?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    fromCity?: string | undefined;
    fromState?: string | undefined;
    fromZip?: string | undefined;
    fromCountry?: string | undefined;
    toCity?: string | undefined;
    toState?: string | undefined;
    toZip?: string | undefined;
    toCountry?: string | undefined;

    constructor(data?: ITwilioRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountSid = _data["AccountSid"];
            this.from = _data["From"];
            this.to = _data["To"];
            this.fromCity = _data["FromCity"];
            this.fromState = _data["FromState"];
            this.fromZip = _data["FromZip"];
            this.fromCountry = _data["FromCountry"];
            this.toCity = _data["ToCity"];
            this.toState = _data["ToState"];
            this.toZip = _data["ToZip"];
            this.toCountry = _data["ToCountry"];
        }
    }

    static fromJS(data: any): TwilioRequest {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TwilioRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountSid"] = this.accountSid;
        data["From"] = this.from;
        data["To"] = this.to;
        data["FromCity"] = this.fromCity;
        data["FromState"] = this.fromState;
        data["FromZip"] = this.fromZip;
        data["FromCountry"] = this.fromCountry;
        data["ToCity"] = this.toCity;
        data["ToState"] = this.toState;
        data["ToZip"] = this.toZip;
        data["ToCountry"] = this.toCountry;
        return data;
    }
}

export interface ITwilioRequest {
    accountSid?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    fromCity?: string | undefined;
    fromState?: string | undefined;
    fromZip?: string | undefined;
    fromCountry?: string | undefined;
    toCity?: string | undefined;
    toState?: string | undefined;
    toZip?: string | undefined;
    toCountry?: string | undefined;
}

export class SmsRequest extends TwilioRequest implements ISmsRequest {
    smsSid?: string | undefined;
    body?: string | undefined;
    messageStatus?: string | undefined;
    optOutType?: string | undefined;
    messagingServiceSid?: string | undefined;

    constructor(data?: ISmsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.smsSid = _data["SmsSid"];
            this.body = _data["Body"];
            this.messageStatus = _data["MessageStatus"];
            this.optOutType = _data["OptOutType"];
            this.messagingServiceSid = _data["MessagingServiceSid"];
        }
    }

    static fromJS(data: any): SmsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SmsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SmsSid"] = this.smsSid;
        data["Body"] = this.body;
        data["MessageStatus"] = this.messageStatus;
        data["OptOutType"] = this.optOutType;
        data["MessagingServiceSid"] = this.messagingServiceSid;
        super.toJSON(data);
        return data;
    }
}

export interface ISmsRequest extends ITwilioRequest {
    smsSid?: string | undefined;
    body?: string | undefined;
    messageStatus?: string | undefined;
    optOutType?: string | undefined;
    messagingServiceSid?: string | undefined;
}

/** Contains the definition of an object of type BaseEditTechnician. */
export abstract class BaseEditTechnician implements IBaseEditTechnician {
    /** Gets or sets the manager email. */
    managerEmail!: string;
    /** Gets or sets the manager phone. */
    managerPhone!: string;
    /** Gets or sets the technician email. */
    technicianEmail?: string | undefined;
    /** Gets or sets the technician phone. */
    technicianPhone!: string;
    /** Gets or sets a value indicating whether [permanent access]. */
    permanentAccess!: boolean;

    constructor(data?: IBaseEditTechnician) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.managerEmail = _data["managerEmail"];
            this.managerPhone = _data["managerPhone"];
            this.technicianEmail = _data["technicianEmail"];
            this.technicianPhone = _data["technicianPhone"];
            this.permanentAccess = _data["permanentAccess"];
        }
    }

    static fromJS(data: any): BaseEditTechnician {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEditTechnician' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managerEmail"] = this.managerEmail;
        data["managerPhone"] = this.managerPhone;
        data["technicianEmail"] = this.technicianEmail;
        data["technicianPhone"] = this.technicianPhone;
        data["permanentAccess"] = this.permanentAccess;
        return data;
    }
}

/** Contains the definition of an object of type BaseEditTechnician. */
export interface IBaseEditTechnician {
    /** Gets or sets the manager email. */
    managerEmail: string;
    /** Gets or sets the manager phone. */
    managerPhone: string;
    /** Gets or sets the technician email. */
    technicianEmail?: string | undefined;
    /** Gets or sets the technician phone. */
    technicianPhone: string;
    /** Gets or sets a value indicating whether [permanent access]. */
    permanentAccess: boolean;
}

/** Contains the definition of an object of type CreateTechnician. */
export class CreateTechnician extends BaseEditTechnician implements ICreateTechnician {
    /** Gets or sets the name. */
    name!: string;
    /** Gets or sets the partner identifier. */
    partnerId!: number;

    constructor(data?: ICreateTechnician) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.partnerId = _data["partnerId"];
        }
    }

    static fromJS(data: any): CreateTechnician {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTechnician();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["partnerId"] = this.partnerId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateTechnician. */
export interface ICreateTechnician extends IBaseEditTechnician {
    /** Gets or sets the name. */
    name: string;
    /** Gets or sets the partner identifier. */
    partnerId: number;
}

/** Contains the definition of an object of type Technician. */
export class Technician implements ITechnician {
    /** Gets or sets a value indicating whether this Technician can be disabled. */
    canBeDisabled!: boolean;
    /** Gets or sets a value indicating whether [permanent access]. */
    permanentAccess!: boolean;
    /** Gets or sets a value indicating whether this Technician is disabled. */
    disabled!: boolean;
    /** Gets the groups. */
    groups?: string[] | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the intervention count. */
    interventionCount!: number;
    /** Gets or sets the manager email. */
    managerEmail?: string | undefined;
    /** Gets or sets the manager phone. */
    managerPhone?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the partner. */
    partner?: PartnerLight | undefined;
    /** Gets or sets the technician email. */
    technicianEmail?: string | undefined;
    /** Gets or sets the technician phone. */
    technicianPhone?: string | undefined;

    constructor(data?: ITechnician) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canBeDisabled = _data["canBeDisabled"];
            this.permanentAccess = _data["permanentAccess"];
            this.disabled = _data["disabled"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
            this.id = _data["id"];
            this.interventionCount = _data["interventionCount"];
            this.managerEmail = _data["managerEmail"];
            this.managerPhone = _data["managerPhone"];
            this.name = _data["name"];
            this.partner = _data["partner"] ? PartnerLight.fromJS(_data["partner"]) : <any>undefined;
            this.technicianEmail = _data["technicianEmail"];
            this.technicianPhone = _data["technicianPhone"];
        }
    }

    static fromJS(data: any): Technician {
        data = typeof data === 'object' ? data : {};
        let result = new Technician();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canBeDisabled"] = this.canBeDisabled;
        data["permanentAccess"] = this.permanentAccess;
        data["disabled"] = this.disabled;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["id"] = this.id;
        data["interventionCount"] = this.interventionCount;
        data["managerEmail"] = this.managerEmail;
        data["managerPhone"] = this.managerPhone;
        data["name"] = this.name;
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        data["technicianEmail"] = this.technicianEmail;
        data["technicianPhone"] = this.technicianPhone;
        return data;
    }
}

/** Contains the definition of an object of type Technician. */
export interface ITechnician {
    /** Gets or sets a value indicating whether this Technician can be disabled. */
    canBeDisabled: boolean;
    /** Gets or sets a value indicating whether [permanent access]. */
    permanentAccess: boolean;
    /** Gets or sets a value indicating whether this Technician is disabled. */
    disabled: boolean;
    /** Gets the groups. */
    groups?: string[] | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the intervention count. */
    interventionCount: number;
    /** Gets or sets the manager email. */
    managerEmail?: string | undefined;
    /** Gets or sets the manager phone. */
    managerPhone?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the partner. */
    partner?: PartnerLight | undefined;
    /** Gets or sets the technician email. */
    technicianEmail?: string | undefined;
    /** Gets or sets the technician phone. */
    technicianPhone?: string | undefined;
}

/** Contains the definition of an object of type TechnicianSearchParams. */
export class TechnicianSearchParams implements ITechnicianSearchParams {
    /** Gets or sets a value indicating whether disabled technicians should be excluded from result. */
    excludeDisabled!: boolean;
    /** Gets or sets a value indicating whether this instance has temporary access. */
    hasTemporaryAccess!: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the operator identifiers. */
    operatorIds?: number[] | undefined;
    /** Gets or sets the partner identifier. */
    partnerId?: number | undefined;
    /** Gets or sets the phone. */
    phone?: string | undefined;

    constructor(data?: ITechnicianSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.excludeDisabled = _data["excludeDisabled"];
            this.hasTemporaryAccess = _data["hasTemporaryAccess"];
            this.name = _data["name"];
            if (Array.isArray(_data["operatorIds"])) {
                this.operatorIds = [] as any;
                for (let item of _data["operatorIds"])
                    this.operatorIds!.push(item);
            }
            this.partnerId = _data["partnerId"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): TechnicianSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicianSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["excludeDisabled"] = this.excludeDisabled;
        data["hasTemporaryAccess"] = this.hasTemporaryAccess;
        data["name"] = this.name;
        if (Array.isArray(this.operatorIds)) {
            data["operatorIds"] = [];
            for (let item of this.operatorIds)
                data["operatorIds"].push(item);
        }
        data["partnerId"] = this.partnerId;
        data["phone"] = this.phone;
        return data;
    }
}

/** Contains the definition of an object of type TechnicianSearchParams. */
export interface ITechnicianSearchParams {
    /** Gets or sets a value indicating whether disabled technicians should be excluded from result. */
    excludeDisabled: boolean;
    /** Gets or sets a value indicating whether this instance has temporary access. */
    hasTemporaryAccess: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the operator identifiers. */
    operatorIds?: number[] | undefined;
    /** Gets or sets the partner identifier. */
    partnerId?: number | undefined;
    /** Gets or sets the phone. */
    phone?: string | undefined;
}

/** Contains the definition of an object of type TechnicianPaginatedSearchParams. */
export class TechnicianPaginatedSearchParams extends TechnicianSearchParams implements ITechnicianPaginatedSearchParams {
    /** Gets or sets the page. 0 is the first page. */
    page!: number;
    /** Gets or sets the size of the page. */
    pageSize!: number;

    constructor(data?: ITechnicianPaginatedSearchParams) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): TechnicianPaginatedSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicianPaginatedSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type TechnicianPaginatedSearchParams. */
export interface ITechnicianPaginatedSearchParams extends ITechnicianSearchParams {
    /** Gets or sets the page. 0 is the first page. */
    page: number;
    /** Gets or sets the size of the page. */
    pageSize: number;
}

/** Contains the definition of an object of type SelectItem`1. */
export class SelectItemOfInteger implements ISelectItemOfInteger {
    /** Gets or sets the label. */
    label?: string | undefined;
    /** Gets or sets the value. */
    value!: number;

    constructor(data?: ISelectItemOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SelectItemOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItemOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

/** Contains the definition of an object of type SelectItem`1. */
export interface ISelectItemOfInteger {
    /** Gets or sets the label. */
    label?: string | undefined;
    /** Gets or sets the value. */
    value: number;
}

/** Contains the definition of an object of type TechnicianImportError. */
export class TechnicianImportError implements ITechnicianImportError {
    /** Gets or sets the line. */
    line?: string | undefined;
    /** Gets or sets the line number. */
    lineNumber!: number;
    /** Gets or sets the type. */
    type!: TechnicianImportErrorType;
    /** Gets or sets the value. */
    value?: string | undefined;

    constructor(data?: ITechnicianImportError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line = _data["line"];
            this.lineNumber = _data["lineNumber"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TechnicianImportError {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicianImportError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line"] = this.line;
        data["lineNumber"] = this.lineNumber;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

/** Contains the definition of an object of type TechnicianImportError. */
export interface ITechnicianImportError {
    /** Gets or sets the line. */
    line?: string | undefined;
    /** Gets or sets the line number. */
    lineNumber: number;
    /** Gets or sets the type. */
    type: TechnicianImportErrorType;
    /** Gets or sets the value. */
    value?: string | undefined;
}

/** Contains the definition of TechnicianImportErrorType. */
export enum TechnicianImportErrorType {
    Unknown = 0,
    LineTooShort = 1,
    LineTooLong = 2,
    TechnicianNameNotAvailable = 3,
    PartnerNameNotUnique = 4,
    PartnerNameNotFound = 5,
    PhoneNumberInvalid = 6,
    EmailInvalid = 7,
    PartnerNotManaged = 8,
}

/** Contains the definition of an object of type TechnicianImport. */
export class TechnicianImport implements ITechnicianImport {
    /** Gets or sets the file. */
    file!: any;

    constructor(data?: ITechnicianImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): TechnicianImport {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicianImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        return data;
    }
}

/** Contains the definition of an object of type TechnicianImport. */
export interface ITechnicianImport {
    /** Gets or sets the file. */
    file: any;
}

/** Contains the definition of an object of type UpdateTechnician. */
export class UpdateTechnician extends BaseEditTechnician implements IUpdateTechnician {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdateTechnician) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTechnician {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTechnician();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateTechnician. */
export interface IUpdateTechnician extends IBaseEditTechnician {
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type StatusValueResponse`1. */
export class StatusValueResponseOfString implements IStatusValueResponseOfString {
    /** Gets or sets the status. */
    status!: ResponseStatus;
    /** Gets or sets the value. */
    value?: string | undefined;

    constructor(data?: IStatusValueResponseOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StatusValueResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new StatusValueResponseOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["value"] = this.value;
        return data;
    }
}

/** Contains the definition of an object of type StatusValueResponse`1. */
export interface IStatusValueResponseOfString {
    /** Gets or sets the status. */
    status: ResponseStatus;
    /** Gets or sets the value. */
    value?: string | undefined;
}

/** Contains the definition of an object of type BaseEditPartner. */
export abstract class BaseEditPartner implements IBaseEditPartner {
    /** Gets or sets the email. */
    email!: string;
    /** Gets or sets the operator ids. */
    operatorIds!: number[];
    /** Gets or sets the phone. */
    phone!: string;

    constructor(data?: IBaseEditPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.operatorIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            if (Array.isArray(_data["operatorIds"])) {
                this.operatorIds = [] as any;
                for (let item of _data["operatorIds"])
                    this.operatorIds!.push(item);
            }
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): BaseEditPartner {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEditPartner' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        if (Array.isArray(this.operatorIds)) {
            data["operatorIds"] = [];
            for (let item of this.operatorIds)
                data["operatorIds"].push(item);
        }
        data["phone"] = this.phone;
        return data;
    }
}

/** Contains the definition of an object of type BaseEditPartner. */
export interface IBaseEditPartner {
    /** Gets or sets the email. */
    email: string;
    /** Gets or sets the operator ids. */
    operatorIds: number[];
    /** Gets or sets the phone. */
    phone: string;
}

/** Contains the definition of an object of type CreatePartner. */
export class CreatePartner extends BaseEditPartner implements ICreatePartner {
    /** Gets or sets the name. */
    name!: string;
    /** Gets or sets the prefix for technicians. */
    prefixForTechnicians!: string;

    constructor(data?: ICreatePartner) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.prefixForTechnicians = _data["prefixForTechnicians"];
        }
    }

    static fromJS(data: any): CreatePartner {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["prefixForTechnicians"] = this.prefixForTechnicians;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreatePartner. */
export interface ICreatePartner extends IBaseEditPartner {
    /** Gets or sets the name. */
    name: string;
    /** Gets or sets the prefix for technicians. */
    prefixForTechnicians: string;
}

/** Contains the definition of an object of type Partner. */
export class Partner extends PartnerLight implements IPartner {
    /** Gets or sets the operators. */
    operators?: OperatorLight[] | undefined;
    /** Gets or sets the prefix for technicians. */
    prefixForTechnicians?: string | undefined;

    constructor(data?: IPartner) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["operators"])) {
                this.operators = [] as any;
                for (let item of _data["operators"])
                    this.operators!.push(OperatorLight.fromJS(item));
            }
            this.prefixForTechnicians = _data["prefixForTechnicians"];
        }
    }

    static fromJS(data: any): Partner {
        data = typeof data === 'object' ? data : {};
        let result = new Partner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operators)) {
            data["operators"] = [];
            for (let item of this.operators)
                data["operators"].push(item.toJSON());
        }
        data["prefixForTechnicians"] = this.prefixForTechnicians;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type Partner. */
export interface IPartner extends IPartnerLight {
    /** Gets or sets the operators. */
    operators?: OperatorLight[] | undefined;
    /** Gets or sets the prefix for technicians. */
    prefixForTechnicians?: string | undefined;
}

/** Contains the definition of an object of type PartnerSearchParams. */
export class PartnerSearchParams implements IPartnerSearchParams {
    /** Gets or sets the cabinet identifier. */
    interventionCabinetId?: number | undefined;
    /** Gets or sets the operator identifiers. */
    operatorIds?: number[] | undefined;

    constructor(data?: IPartnerSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionCabinetId = _data["interventionCabinetId"];
            if (Array.isArray(_data["operatorIds"])) {
                this.operatorIds = [] as any;
                for (let item of _data["operatorIds"])
                    this.operatorIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PartnerSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionCabinetId"] = this.interventionCabinetId;
        if (Array.isArray(this.operatorIds)) {
            data["operatorIds"] = [];
            for (let item of this.operatorIds)
                data["operatorIds"].push(item);
        }
        return data;
    }
}

/** Contains the definition of an object of type PartnerSearchParams. */
export interface IPartnerSearchParams {
    /** Gets or sets the cabinet identifier. */
    interventionCabinetId?: number | undefined;
    /** Gets or sets the operator identifiers. */
    operatorIds?: number[] | undefined;
}

/** Contains the definition of an object of type PartnerPaginatedSearchParams. */
export class PartnerPaginatedSearchParams extends PartnerSearchParams implements IPartnerPaginatedSearchParams {
    /** Gets or sets the page. 0 is the first page. */
    page!: number;
    /** Gets or sets the size of the page. */
    pageSize!: number;

    constructor(data?: IPartnerPaginatedSearchParams) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PartnerPaginatedSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerPaginatedSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PartnerPaginatedSearchParams. */
export interface IPartnerPaginatedSearchParams extends IPartnerSearchParams {
    /** Gets or sets the page. 0 is the first page. */
    page: number;
    /** Gets or sets the size of the page. */
    pageSize: number;
}

/** Contains the definition of an object of type UpdatePartner. */
export class UpdatePartner extends BaseEditPartner implements IUpdatePartner {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdatePartner) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePartner {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdatePartner. */
export interface IUpdatePartner extends IBaseEditPartner {
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type BaseEditCabinet. */
export abstract class BaseEditCabinet implements IBaseEditCabinet {
    /** Gets or sets the AppKey. */
    appKey!: string;
    /** Gets or sets the AppEui. */
    appEui!: string;
    /** Gets or sets the address. */
    address!: string;
    /** Gets or sets the address notes. */
    addressNotes?: string | undefined;
    /** Gets or sets the city. */
    city!: string;
    /** Gets or sets the commercial operator ids. */
    commercialOperatorIds?: number[] | undefined;
    /** Gets or sets the el count. */
    elCount?: number | undefined;
    /** Gets or sets the imei number. */
    imeiNumber?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode!: string;
    /** Gets or sets the prom. */
    prom?: number | undefined;
    /** Gets or sets the technical point. */
    technicalPoint?: string | undefined;
    /** Gets or sets the type. */
    type!: CabinetType;
    /** Gets or sets the usage start date. */
    usageStartDate?: Date | undefined;

    constructor(data?: IBaseEditCabinet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appKey = _data["appKey"];
            this.appEui = _data["appEui"];
            this.address = _data["address"];
            this.addressNotes = _data["addressNotes"];
            this.city = _data["city"];
            if (Array.isArray(_data["commercialOperatorIds"])) {
                this.commercialOperatorIds = [] as any;
                for (let item of _data["commercialOperatorIds"])
                    this.commercialOperatorIds!.push(item);
            }
            this.elCount = _data["elCount"];
            this.imeiNumber = _data["imeiNumber"];
            this.postalCode = _data["postalCode"];
            this.prom = _data["prom"];
            this.technicalPoint = _data["technicalPoint"];
            this.type = _data["type"];
            this.usageStartDate = _data["usageStartDate"] ? new Date(_data["usageStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseEditCabinet {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEditCabinet' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appKey"] = this.appKey;
        data["appEui"] = this.appEui;
        data["address"] = this.address;
        data["addressNotes"] = this.addressNotes;
        data["city"] = this.city;
        if (Array.isArray(this.commercialOperatorIds)) {
            data["commercialOperatorIds"] = [];
            for (let item of this.commercialOperatorIds)
                data["commercialOperatorIds"].push(item);
        }
        data["elCount"] = this.elCount;
        data["imeiNumber"] = this.imeiNumber;
        data["postalCode"] = this.postalCode;
        data["prom"] = this.prom;
        data["technicalPoint"] = this.technicalPoint;
        data["type"] = this.type;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type BaseEditCabinet. */
export interface IBaseEditCabinet {
    /** Gets or sets the AppKey. */
    appKey: string;
    /** Gets or sets the AppEui. */
    appEui: string;
    /** Gets or sets the address. */
    address: string;
    /** Gets or sets the address notes. */
    addressNotes?: string | undefined;
    /** Gets or sets the city. */
    city: string;
    /** Gets or sets the commercial operator ids. */
    commercialOperatorIds?: number[] | undefined;
    /** Gets or sets the el count. */
    elCount?: number | undefined;
    /** Gets or sets the imei number. */
    imeiNumber?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode: string;
    /** Gets or sets the prom. */
    prom?: number | undefined;
    /** Gets or sets the technical point. */
    technicalPoint?: string | undefined;
    /** Gets or sets the type. */
    type: CabinetType;
    /** Gets or sets the usage start date. */
    usageStartDate?: Date | undefined;
}

/** Contains the definition of an object of type CreateCabinet. */
export class CreateCabinet extends BaseEditCabinet implements ICreateCabinet {
    /** Gets or sets the CabinetProtocol. */
    cabinetProtocol!: CabinetProtocol;
    /** Gets or sets the infrastructure operator identifier. */
    infrastructureOperatorId!: number;
    /** Gets or sets the name. */
    name!: string;

    constructor(data?: ICreateCabinet) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cabinetProtocol = _data["cabinetProtocol"];
            this.infrastructureOperatorId = _data["infrastructureOperatorId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCabinet {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCabinet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinetProtocol"] = this.cabinetProtocol;
        data["infrastructureOperatorId"] = this.infrastructureOperatorId;
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateCabinet. */
export interface ICreateCabinet extends IBaseEditCabinet {
    /** Gets or sets the CabinetProtocol. */
    cabinetProtocol: CabinetProtocol;
    /** Gets or sets the infrastructure operator identifier. */
    infrastructureOperatorId: number;
    /** Gets or sets the name. */
    name: string;
}

/** Contains the definition of CabinetProtocol. */
export enum CabinetProtocol {
    Ltem = 0,
    Lora = 1,
}

/** Contains the definition of an object of type Cabinet. */
export class Cabinet implements ICabinet {
    /** Gets or sets the AppKey. */
    appKey?: string | undefined;
    /** Gets or sets the AppEui. */
    appEui?: string | undefined;
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the address notes. */
    addressNotes?: string | undefined;
    /** Gets or sets the alarms. */
    alarms?: Alarm[] | undefined;
    /** Gets or sets the CabinetProtocol. */
    cabinetProtocol!: CabinetProtocol;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the commercial operators. */
    commercialOperators?: OperatorLight[] | undefined;
    /** Gets or sets the el count. */
    elCount?: number | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the imei number. */
    imeiNumber?: string | undefined;
    /** Gets or sets the intervention count. */
    interventionCount!: number;
    /** Gets or sets the infrastructure operator. */
    infrastructureOperator?: OperatorLight | undefined;
    /** Gets or sets the latitude. */
    latitude?: number | undefined;
    /** Gets or sets the longitude. */
    longitude?: number | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the partner count. */
    partnerCount!: number;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the prom. */
    prom?: number | undefined;
    /** Gets or sets the battery level. */
    batteryLevel?: number | undefined;
    /** Gets or sets the state. */
    state!: CabinetState;
    /** Gets or sets the technical point. */
    technicalPoint?: string | undefined;
    /** Gets or sets the type. */
    type!: CabinetType;
    /** Gets or sets the usage start date. */
    usageStartDate?: Date | undefined;
    /** Gets or sets the pictures. */
    pictures?: CabinetPicture[] | undefined;
    /** Gets or sets the QrCodePath. */
    qrCodePath?: string | undefined;

    constructor(data?: ICabinet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appKey = _data["appKey"];
            this.appEui = _data["appEui"];
            this.address = _data["address"];
            this.addressNotes = _data["addressNotes"];
            if (Array.isArray(_data["alarms"])) {
                this.alarms = [] as any;
                for (let item of _data["alarms"])
                    this.alarms!.push(Alarm.fromJS(item));
            }
            this.cabinetProtocol = _data["cabinetProtocol"];
            this.city = _data["city"];
            if (Array.isArray(_data["commercialOperators"])) {
                this.commercialOperators = [] as any;
                for (let item of _data["commercialOperators"])
                    this.commercialOperators!.push(OperatorLight.fromJS(item));
            }
            this.elCount = _data["elCount"];
            this.id = _data["id"];
            this.imeiNumber = _data["imeiNumber"];
            this.interventionCount = _data["interventionCount"];
            this.infrastructureOperator = _data["infrastructureOperator"] ? OperatorLight.fromJS(_data["infrastructureOperator"]) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.name = _data["name"];
            this.partnerCount = _data["partnerCount"];
            this.postalCode = _data["postalCode"];
            this.prom = _data["prom"];
            this.batteryLevel = _data["batteryLevel"];
            this.state = _data["state"];
            this.technicalPoint = _data["technicalPoint"];
            this.type = _data["type"];
            this.usageStartDate = _data["usageStartDate"] ? new Date(_data["usageStartDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["pictures"])) {
                this.pictures = [] as any;
                for (let item of _data["pictures"])
                    this.pictures!.push(CabinetPicture.fromJS(item));
            }
            this.qrCodePath = _data["qrCodePath"];
        }
    }

    static fromJS(data: any): Cabinet {
        data = typeof data === 'object' ? data : {};
        let result = new Cabinet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appKey"] = this.appKey;
        data["appEui"] = this.appEui;
        data["address"] = this.address;
        data["addressNotes"] = this.addressNotes;
        if (Array.isArray(this.alarms)) {
            data["alarms"] = [];
            for (let item of this.alarms)
                data["alarms"].push(item.toJSON());
        }
        data["cabinetProtocol"] = this.cabinetProtocol;
        data["city"] = this.city;
        if (Array.isArray(this.commercialOperators)) {
            data["commercialOperators"] = [];
            for (let item of this.commercialOperators)
                data["commercialOperators"].push(item.toJSON());
        }
        data["elCount"] = this.elCount;
        data["id"] = this.id;
        data["imeiNumber"] = this.imeiNumber;
        data["interventionCount"] = this.interventionCount;
        data["infrastructureOperator"] = this.infrastructureOperator ? this.infrastructureOperator.toJSON() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["name"] = this.name;
        data["partnerCount"] = this.partnerCount;
        data["postalCode"] = this.postalCode;
        data["prom"] = this.prom;
        data["batteryLevel"] = this.batteryLevel;
        data["state"] = this.state;
        data["technicalPoint"] = this.technicalPoint;
        data["type"] = this.type;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.toISOString() : <any>undefined;
        if (Array.isArray(this.pictures)) {
            data["pictures"] = [];
            for (let item of this.pictures)
                data["pictures"].push(item.toJSON());
        }
        data["qrCodePath"] = this.qrCodePath;
        return data;
    }
}

/** Contains the definition of an object of type Cabinet. */
export interface ICabinet {
    /** Gets or sets the AppKey. */
    appKey?: string | undefined;
    /** Gets or sets the AppEui. */
    appEui?: string | undefined;
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the address notes. */
    addressNotes?: string | undefined;
    /** Gets or sets the alarms. */
    alarms?: Alarm[] | undefined;
    /** Gets or sets the CabinetProtocol. */
    cabinetProtocol: CabinetProtocol;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the commercial operators. */
    commercialOperators?: OperatorLight[] | undefined;
    /** Gets or sets the el count. */
    elCount?: number | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the imei number. */
    imeiNumber?: string | undefined;
    /** Gets or sets the intervention count. */
    interventionCount: number;
    /** Gets or sets the infrastructure operator. */
    infrastructureOperator?: OperatorLight | undefined;
    /** Gets or sets the latitude. */
    latitude?: number | undefined;
    /** Gets or sets the longitude. */
    longitude?: number | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the partner count. */
    partnerCount: number;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the prom. */
    prom?: number | undefined;
    /** Gets or sets the battery level. */
    batteryLevel?: number | undefined;
    /** Gets or sets the state. */
    state: CabinetState;
    /** Gets or sets the technical point. */
    technicalPoint?: string | undefined;
    /** Gets or sets the type. */
    type: CabinetType;
    /** Gets or sets the usage start date. */
    usageStartDate?: Date | undefined;
    /** Gets or sets the pictures. */
    pictures?: CabinetPicture[] | undefined;
    /** Gets or sets the QrCodePath. */
    qrCodePath?: string | undefined;
}

/** Contains the definition of an object of type Alarm. */
export class Alarm implements IAlarm {
    /** Gets or sets the cabinet identifier. */
    cabinetId!: number;
    /** Gets or sets the type. */
    type!: AlarmType;
    /** Gets or sets the opening date. */
    alarmDate?: Date | undefined;

    constructor(data?: IAlarm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cabinetId = _data["cabinetId"];
            this.type = _data["type"];
            this.alarmDate = _data["alarmDate"] ? new Date(_data["alarmDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Alarm {
        data = typeof data === 'object' ? data : {};
        let result = new Alarm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinetId"] = this.cabinetId;
        data["type"] = this.type;
        data["alarmDate"] = this.alarmDate ? this.alarmDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type Alarm. */
export interface IAlarm {
    /** Gets or sets the cabinet identifier. */
    cabinetId: number;
    /** Gets or sets the type. */
    type: AlarmType;
    /** Gets or sets the opening date. */
    alarmDate?: Date | undefined;
}

/** Contains the definition of AlarmType. */
export enum AlarmType {
    Unknown = 0,
    ForcedOpening = 1,
    OpeningTooLong = 2,
    KeysNotReturnedOnTime = 3,
    NoDailyOperation = 4,
    LowBatteryLevel = 5,
}

/** Contains the definition of an object of type CabinetPicture. */
export class CabinetPicture implements ICabinetPicture {
    /** Gets or sets the picture URL. */
    pictureUrl?: string | undefined;
    /** Gets or sets the picture path. */
    picturePath?: string | undefined;

    constructor(data?: ICabinetPicture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pictureUrl = _data["pictureUrl"];
            this.picturePath = _data["picturePath"];
        }
    }

    static fromJS(data: any): CabinetPicture {
        data = typeof data === 'object' ? data : {};
        let result = new CabinetPicture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureUrl"] = this.pictureUrl;
        data["picturePath"] = this.picturePath;
        return data;
    }
}

/** Contains the definition of an object of type CabinetPicture. */
export interface ICabinetPicture {
    /** Gets or sets the picture URL. */
    pictureUrl?: string | undefined;
    /** Gets or sets the picture path. */
    picturePath?: string | undefined;
}

/** Contains the definition of an object of type CabinetSearchParams. */
export class CabinetSearchParams implements ICabinetSearchParams {
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the city or postal code. */
    cityId?: number | undefined;
    /** Gets or sets the commercial operator identifiers. */
    commercialOperatorIds?: number[] | undefined;
    /** Gets or sets the identifier. */
    id?: number | undefined;
    /** Gets or sets the imei number. */
    imeiNumber?: string | undefined;
    /** Gets or sets the infrastructure operator identifiers. */
    infrastructureOperatorIds?: number[] | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the operator identifier. */
    operatorIds?: number[] | undefined;
    /** Gets or sets the prom. */
    prom?: number | undefined;
    /** Gets or sets the radius in kilometers. */
    radius?: number | undefined;
    /** Gets or sets a value indicating whether [show only in alert]. */
    showOnlyInAlert!: boolean;

    constructor(data?: ICabinetSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.cityId = _data["cityId"];
            if (Array.isArray(_data["commercialOperatorIds"])) {
                this.commercialOperatorIds = [] as any;
                for (let item of _data["commercialOperatorIds"])
                    this.commercialOperatorIds!.push(item);
            }
            this.id = _data["id"];
            this.imeiNumber = _data["imeiNumber"];
            if (Array.isArray(_data["infrastructureOperatorIds"])) {
                this.infrastructureOperatorIds = [] as any;
                for (let item of _data["infrastructureOperatorIds"])
                    this.infrastructureOperatorIds!.push(item);
            }
            this.name = _data["name"];
            if (Array.isArray(_data["operatorIds"])) {
                this.operatorIds = [] as any;
                for (let item of _data["operatorIds"])
                    this.operatorIds!.push(item);
            }
            this.prom = _data["prom"];
            this.radius = _data["radius"];
            this.showOnlyInAlert = _data["showOnlyInAlert"];
        }
    }

    static fromJS(data: any): CabinetSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new CabinetSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["cityId"] = this.cityId;
        if (Array.isArray(this.commercialOperatorIds)) {
            data["commercialOperatorIds"] = [];
            for (let item of this.commercialOperatorIds)
                data["commercialOperatorIds"].push(item);
        }
        data["id"] = this.id;
        data["imeiNumber"] = this.imeiNumber;
        if (Array.isArray(this.infrastructureOperatorIds)) {
            data["infrastructureOperatorIds"] = [];
            for (let item of this.infrastructureOperatorIds)
                data["infrastructureOperatorIds"].push(item);
        }
        data["name"] = this.name;
        if (Array.isArray(this.operatorIds)) {
            data["operatorIds"] = [];
            for (let item of this.operatorIds)
                data["operatorIds"].push(item);
        }
        data["prom"] = this.prom;
        data["radius"] = this.radius;
        data["showOnlyInAlert"] = this.showOnlyInAlert;
        return data;
    }
}

/** Contains the definition of an object of type CabinetSearchParams. */
export interface ICabinetSearchParams {
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the city or postal code. */
    cityId?: number | undefined;
    /** Gets or sets the commercial operator identifiers. */
    commercialOperatorIds?: number[] | undefined;
    /** Gets or sets the identifier. */
    id?: number | undefined;
    /** Gets or sets the imei number. */
    imeiNumber?: string | undefined;
    /** Gets or sets the infrastructure operator identifiers. */
    infrastructureOperatorIds?: number[] | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the operator identifier. */
    operatorIds?: number[] | undefined;
    /** Gets or sets the prom. */
    prom?: number | undefined;
    /** Gets or sets the radius in kilometers. */
    radius?: number | undefined;
    /** Gets or sets a value indicating whether [show only in alert]. */
    showOnlyInAlert: boolean;
}

/** Contains the definition of an object of type CabinetPaginatedSearchParams. */
export class CabinetPaginatedSearchParams extends CabinetSearchParams implements ICabinetPaginatedSearchParams {
    /** Gets or sets the page. 0 is the first page. */
    page!: number;
    /** Gets or sets the size of the page. */
    pageSize!: number;

    constructor(data?: ICabinetPaginatedSearchParams) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): CabinetPaginatedSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new CabinetPaginatedSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CabinetPaginatedSearchParams. */
export interface ICabinetPaginatedSearchParams extends ICabinetSearchParams {
    /** Gets or sets the page. 0 is the first page. */
    page: number;
    /** Gets or sets the size of the page. */
    pageSize: number;
}

/** Contains the definition of an object of type CabinetStateAndAlarms. */
export class CabinetStateAndAlarms implements ICabinetStateAndAlarms {
    /** Gets or sets the alarms. */
    alarms?: Alarm[] | undefined;
    /** Gets or sets the cabinet identifier. */
    cabinetId!: number;
    /** Gets or sets the state. */
    state!: CabinetState;

    constructor(data?: ICabinetStateAndAlarms) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["alarms"])) {
                this.alarms = [] as any;
                for (let item of _data["alarms"])
                    this.alarms!.push(Alarm.fromJS(item));
            }
            this.cabinetId = _data["cabinetId"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): CabinetStateAndAlarms {
        data = typeof data === 'object' ? data : {};
        let result = new CabinetStateAndAlarms();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.alarms)) {
            data["alarms"] = [];
            for (let item of this.alarms)
                data["alarms"].push(item.toJSON());
        }
        data["cabinetId"] = this.cabinetId;
        data["state"] = this.state;
        return data;
    }
}

/** Contains the definition of an object of type CabinetStateAndAlarms. */
export interface ICabinetStateAndAlarms {
    /** Gets or sets the alarms. */
    alarms?: Alarm[] | undefined;
    /** Gets or sets the cabinet identifier. */
    cabinetId: number;
    /** Gets or sets the state. */
    state: CabinetState;
}

/** Contains the definition of an object of type CabinetImportError. */
export class CabinetImportError implements ICabinetImportError {
    /** Gets or sets the line. */
    line?: string | undefined;
    /** Gets or sets the line number. */
    lineNumber!: number;
    /** Gets or sets the type. */
    type!: CabinetImportErrorType;
    /** Gets or sets the value. */
    value?: string | undefined;

    constructor(data?: ICabinetImportError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line = _data["line"];
            this.lineNumber = _data["lineNumber"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CabinetImportError {
        data = typeof data === 'object' ? data : {};
        let result = new CabinetImportError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line"] = this.line;
        data["lineNumber"] = this.lineNumber;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

/** Contains the definition of an object of type CabinetImportError. */
export interface ICabinetImportError {
    /** Gets or sets the line. */
    line?: string | undefined;
    /** Gets or sets the line number. */
    lineNumber: number;
    /** Gets or sets the type. */
    type: CabinetImportErrorType;
    /** Gets or sets the value. */
    value?: string | undefined;
}

/** Contains the definition of an object of type CabinetImportErrorType. */
export enum CabinetImportErrorType {
    Unknown = 0,
    LineTooShort = 1,
    LineTooLong = 2,
    CabinetNameNotAvailable = 3,
    CabinetImeiNumberNotAvailable = 4,
    InfraOperatorNameNotFound = 5,
    InfraOperatorNameNotUnique = 6,
    UsageStartDateInvalid = 7,
    ElCountInvalid = 8,
    SameCommercialOperatorForCabinet = 9,
    CommercialOperatorNameNotFound = 10,
    CommercialOperatorNameNotUnique = 11,
    CommercialOperatorNotManagedByInfrastructureOperator = 12,
    UserDoesntManageInfraOperator = 13,
    CabinetTypeInvalid = 14,
}

/** Contains the definition of an object of type CabinetImport. */
export class CabinetImport implements ICabinetImport {
    /** Gets or sets the file. */
    file!: any;

    constructor(data?: ICabinetImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): CabinetImport {
        data = typeof data === 'object' ? data : {};
        let result = new CabinetImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        return data;
    }
}

/** Contains the definition of an object of type CabinetImport. */
export interface ICabinetImport {
    /** Gets or sets the file. */
    file: any;
}

/** Contains the definition of an object of type PushDataResponse. */
export class PushDataResponse implements IPushDataResponse {
    /** Gets or sets the is opening authorized. O for true, N for false. */
    o?: string | undefined;

    constructor(data?: IPushDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.o = _data["O"];
        }
    }

    static fromJS(data: any): PushDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PushDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["O"] = this.o;
        return data;
    }
}

/** Contains the definition of an object of type PushDataResponse. */
export interface IPushDataResponse {
    /** Gets or sets the is opening authorized. O for true, N for false. */
    o?: string | undefined;
}

/** Contains the definition of an object of type BaseExternalDeviceResponse. */
export class BaseExternalDeviceResponse implements IBaseExternalDeviceResponse {
    /** Gets or sets Id. */
    id?: string | undefined;
    /** Gets or sets the value. */
    value!: Value;
    /** Gets or sets the Metadata. */
    metadata!: Metadata;
    /** Gets or sets Interfaces. */
    interfaces?: InterfacesRequest[] | undefined;
    /** Gets or sets the Created. */
    created!: Date;

    constructor(data?: IBaseExternalDeviceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.value = new Value();
            this.metadata = new Metadata();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"] ? Value.fromJS(_data["value"]) : new Value();
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : new Metadata();
            if (Array.isArray(_data["interfaces"])) {
                this.interfaces = [] as any;
                for (let item of _data["interfaces"])
                    this.interfaces!.push(InterfacesRequest.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseExternalDeviceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BaseExternalDeviceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        if (Array.isArray(this.interfaces)) {
            data["interfaces"] = [];
            for (let item of this.interfaces)
                data["interfaces"].push(item.toJSON());
        }
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type BaseExternalDeviceResponse. */
export interface IBaseExternalDeviceResponse {
    /** Gets or sets Id. */
    id?: string | undefined;
    /** Gets or sets the value. */
    value: Value;
    /** Gets or sets the Metadata. */
    metadata: Metadata;
    /** Gets or sets Interfaces. */
    interfaces?: InterfacesRequest[] | undefined;
    /** Gets or sets the Created. */
    created: Date;
}

/** Contains the definition of an object of type Value. */
export class Value implements IValue {
    /** Gets or sets The Payload. */
    payload!: string;
    /** Gets or sets The Data. */
    data!: string;

    constructor(data?: IValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payload = _data["payload"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): Value {
        data = typeof data === 'object' ? data : {};
        let result = new Value();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payload"] = this.payload;
        data["data"] = this.data;
        return data;
    }
}

/** Contains the definition of an object of type Value. */
export interface IValue {
    /** Gets or sets The Payload. */
    payload: string;
    /** Gets or sets The Data. */
    data: string;
}

/** Contains the definition of an object of type Network. */
export class Metadata implements IMetadata {
    /** Gets or sets the Network. */
    network!: Network;

    constructor(data?: IMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.network = new Network();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.network = _data["network"] ? Network.fromJS(_data["network"]) : new Network();
        }
    }

    static fromJS(data: any): Metadata {
        data = typeof data === 'object' ? data : {};
        let result = new Metadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["network"] = this.network ? this.network.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type Network. */
export interface IMetadata {
    /** Gets or sets the Network. */
    network: Network;
}

/** Contains the definition of an object of type Network. */
export class Network implements INetwork {
    /** Gets or sets Lora. */
    lora!: Lora;

    constructor(data?: INetwork) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.lora = new Lora();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lora = _data["lora"] ? Lora.fromJS(_data["lora"]) : new Lora();
        }
    }

    static fromJS(data: any): Network {
        data = typeof data === 'object' ? data : {};
        let result = new Network();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lora"] = this.lora ? this.lora.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type Network. */
export interface INetwork {
    /** Gets or sets Lora. */
    lora: Lora;
}

/** Contains the definition of an object of type Lora. */
export class Lora implements ILora {
    /** Gets or Sets the DevEUI. */
    devEUI!: string;

    constructor(data?: ILora) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.devEUI = _data["devEUI"];
        }
    }

    static fromJS(data: any): Lora {
        data = typeof data === 'object' ? data : {};
        let result = new Lora();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["devEUI"] = this.devEUI;
        return data;
    }
}

/** Contains the definition of an object of type Lora. */
export interface ILora {
    /** Gets or Sets the DevEUI. */
    devEUI: string;
}

/** Contains the definition of an object of type InterfacesRequest. */
export class InterfacesRequest implements IInterfacesRequest {
    /** Gets or sets Connector. */
    connector!: string;
    /** Gets or sets a value indicating whether it's Enabled. */
    enabled?: boolean | undefined;
    /** Gets or sets Definition. */
    definition!: DefinitionRequest;

    constructor(data?: IInterfacesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.definition = new DefinitionRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connector = _data["connector"];
            this.enabled = _data["enabled"];
            this.definition = _data["definition"] ? DefinitionRequest.fromJS(_data["definition"]) : new DefinitionRequest();
        }
    }

    static fromJS(data: any): InterfacesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InterfacesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connector"] = this.connector;
        data["enabled"] = this.enabled;
        data["definition"] = this.definition ? this.definition.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type InterfacesRequest. */
export interface IInterfacesRequest {
    /** Gets or sets Connector. */
    connector: string;
    /** Gets or sets a value indicating whether it's Enabled. */
    enabled?: boolean | undefined;
    /** Gets or sets Definition. */
    definition: DefinitionRequest;
}

/** Contains the definition of an object of type DefinitionRequest. */
export class DefinitionRequest implements IDefinitionRequest {
    /** Gets or sets DevEUI. */
    devEUI!: string;
    /** Gets or sets Profile. */
    profile!: string;
    /** Gets or sets ActivationType. */
    activationType!: string;
    /** Gets or sets AppEUI. */
    appEUI!: string;
    /** Gets or sets AppKey. */
    appKey!: string;
    /** Gets or sets ConnectivityOptions. */
    connectivityOptions!: ConnectivityOptionsRequest;
    /** Gets or sets ConnectivityPlan. */
    connectivityPlan!: string;

    constructor(data?: IDefinitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.connectivityOptions = new ConnectivityOptionsRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.devEUI = _data["devEUI"];
            this.profile = _data["profile"];
            this.activationType = _data["activationType"];
            this.appEUI = _data["appEUI"];
            this.appKey = _data["appKey"];
            this.connectivityOptions = _data["connectivityOptions"] ? ConnectivityOptionsRequest.fromJS(_data["connectivityOptions"]) : new ConnectivityOptionsRequest();
            this.connectivityPlan = _data["connectivityPlan"];
        }
    }

    static fromJS(data: any): DefinitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DefinitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["devEUI"] = this.devEUI;
        data["profile"] = this.profile;
        data["activationType"] = this.activationType;
        data["appEUI"] = this.appEUI;
        data["appKey"] = this.appKey;
        data["connectivityOptions"] = this.connectivityOptions ? this.connectivityOptions.toJSON() : <any>undefined;
        data["connectivityPlan"] = this.connectivityPlan;
        return data;
    }
}

/** Contains the definition of an object of type DefinitionRequest. */
export interface IDefinitionRequest {
    /** Gets or sets DevEUI. */
    devEUI: string;
    /** Gets or sets Profile. */
    profile: string;
    /** Gets or sets ActivationType. */
    activationType: string;
    /** Gets or sets AppEUI. */
    appEUI: string;
    /** Gets or sets AppKey. */
    appKey: string;
    /** Gets or sets ConnectivityOptions. */
    connectivityOptions: ConnectivityOptionsRequest;
    /** Gets or sets ConnectivityPlan. */
    connectivityPlan: string;
}

/** Contains the definition of an object of type ConnectivityOptionsRequest. */
export class ConnectivityOptionsRequest implements IConnectivityOptionsRequest {
    /** Gets or sets a value indicating whether it's AckUl. */
    ackUl!: boolean;

    constructor(data?: IConnectivityOptionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ackUl = _data["ackUl"];
        }
    }

    static fromJS(data: any): ConnectivityOptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectivityOptionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ackUl"] = this.ackUl;
        return data;
    }
}

/** Contains the definition of an object of type ConnectivityOptionsRequest. */
export interface IConnectivityOptionsRequest {
    /** Gets or sets a value indicating whether it's AckUl. */
    ackUl: boolean;
}

/** Contains the definition of an object of type TokenRequest. */
export class TokenRequest implements ITokenRequest {
    /** Gets or sets the token. */
    token?: string | undefined;

    constructor(data?: ITokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): TokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

/** Contains the definition of an object of type TokenRequest. */
export interface ITokenRequest {
    /** Gets or sets the token. */
    token?: string | undefined;
}

/** Contains the definition of an object of type OpenCabinetWithNameRequest. */
export class OpenCabinetWithNameRequest extends TokenRequest implements IOpenCabinetWithNameRequest {
    /** Gets or sets the CabinetName. */
    cabinetName?: string | undefined;

    constructor(data?: IOpenCabinetWithNameRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cabinetName = _data["cabinetName"];
        }
    }

    static fromJS(data: any): OpenCabinetWithNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OpenCabinetWithNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinetName"] = this.cabinetName;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type OpenCabinetWithNameRequest. */
export interface IOpenCabinetWithNameRequest extends ITokenRequest {
    /** Gets or sets the CabinetName. */
    cabinetName?: string | undefined;
}

/** Contains the definition of an object of type OpenCabinetWithQrCodeRequest. */
export class OpenCabinetWithQrCodeRequest extends TokenRequest implements IOpenCabinetWithQrCodeRequest {
    /** Gets or sets the imeiNumber. */
    imeiNumber?: string | undefined;

    constructor(data?: IOpenCabinetWithQrCodeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imeiNumber = _data["imeiNumber"];
        }
    }

    static fromJS(data: any): OpenCabinetWithQrCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OpenCabinetWithQrCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imeiNumber"] = this.imeiNumber;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type OpenCabinetWithQrCodeRequest. */
export interface IOpenCabinetWithQrCodeRequest extends ITokenRequest {
    /** Gets or sets the imeiNumber. */
    imeiNumber?: string | undefined;
}

/** Contains the definition of an object of type UpdateCabinet. */
export class UpdateCabinet extends BaseEditCabinet implements IUpdateCabinet {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdateCabinet) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCabinet {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCabinet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateCabinet. */
export interface IUpdateCabinet extends IBaseEditCabinet {
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type StatusValueResponse`1. */
export class StatusValueResponseOfByteOf implements IStatusValueResponseOfByteOf {
    /** Gets or sets the status. */
    status!: ResponseStatus;
    /** Gets or sets the value. */
    value?: string | undefined;

    constructor(data?: IStatusValueResponseOfByteOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StatusValueResponseOfByteOf {
        data = typeof data === 'object' ? data : {};
        let result = new StatusValueResponseOfByteOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["value"] = this.value;
        return data;
    }
}

/** Contains the definition of an object of type StatusValueResponse`1. */
export interface IStatusValueResponseOfByteOf {
    /** Gets or sets the status. */
    status: ResponseStatus;
    /** Gets or sets the value. */
    value?: string | undefined;
}

/** Contains the definition of an object of type BaseEditOperator. */
export abstract class BaseEditOperator implements IBaseEditOperator {
    /** Gets or sets a value indicating whether this instance can create cabinet. */
    canAddOrEditCabinet!: boolean;
    /** Gets or sets the email. */
    email!: string;
    /** Gets or sets the name. */
    name!: string;
    /** Gets or sets the operator ids as commercial operator. */
    operatorIdsAsCommercialOperator?: number[] | undefined;
    /** Gets or sets the phone. */
    phone!: string;

    constructor(data?: IBaseEditOperator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAddOrEditCabinet = _data["canAddOrEditCabinet"];
            this.email = _data["email"];
            this.name = _data["name"];
            if (Array.isArray(_data["operatorIdsAsCommercialOperator"])) {
                this.operatorIdsAsCommercialOperator = [] as any;
                for (let item of _data["operatorIdsAsCommercialOperator"])
                    this.operatorIdsAsCommercialOperator!.push(item);
            }
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): BaseEditOperator {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEditOperator' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAddOrEditCabinet"] = this.canAddOrEditCabinet;
        data["email"] = this.email;
        data["name"] = this.name;
        if (Array.isArray(this.operatorIdsAsCommercialOperator)) {
            data["operatorIdsAsCommercialOperator"] = [];
            for (let item of this.operatorIdsAsCommercialOperator)
                data["operatorIdsAsCommercialOperator"].push(item);
        }
        data["phone"] = this.phone;
        return data;
    }
}

/** Contains the definition of an object of type BaseEditOperator. */
export interface IBaseEditOperator {
    /** Gets or sets a value indicating whether this instance can create cabinet. */
    canAddOrEditCabinet: boolean;
    /** Gets or sets the email. */
    email: string;
    /** Gets or sets the name. */
    name: string;
    /** Gets or sets the operator ids as commercial operator. */
    operatorIdsAsCommercialOperator?: number[] | undefined;
    /** Gets or sets the phone. */
    phone: string;
}

/** Contains the definition of an object of type CreateOperator. */
export class CreateOperator extends BaseEditOperator implements ICreateOperator {
    /** Gets or sets the prefix for technicians. */
    prefixForTechnicians!: string;

    constructor(data?: ICreateOperator) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.prefixForTechnicians = _data["prefixForTechnicians"];
        }
    }

    static fromJS(data: any): CreateOperator {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOperator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefixForTechnicians"] = this.prefixForTechnicians;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateOperator. */
export interface ICreateOperator extends IBaseEditOperator {
    /** Gets or sets the prefix for technicians. */
    prefixForTechnicians: string;
}

/** Contains the definition of an object of type Operator. */
export class Operator extends OperatorLight implements IOperator {
    /** Gets or sets the cabinet count. */
    cabinetCount!: number;
    /** Gets or sets the intervention count. */
    interventionCount!: number;
    /** Gets or sets the member count. */
    memberCount!: number;
    /** Gets or sets the operators as commercial operator. */
    operatorsAsCommercialOperator?: OperatorLight[] | undefined;
    /** Gets or sets the partner count. */
    partnerCount!: number;
    /** Gets or sets the technician count. */
    technicianCount!: number;

    constructor(data?: IOperator) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cabinetCount = _data["cabinetCount"];
            this.interventionCount = _data["interventionCount"];
            this.memberCount = _data["memberCount"];
            if (Array.isArray(_data["operatorsAsCommercialOperator"])) {
                this.operatorsAsCommercialOperator = [] as any;
                for (let item of _data["operatorsAsCommercialOperator"])
                    this.operatorsAsCommercialOperator!.push(OperatorLight.fromJS(item));
            }
            this.partnerCount = _data["partnerCount"];
            this.technicianCount = _data["technicianCount"];
        }
    }

    static fromJS(data: any): Operator {
        data = typeof data === 'object' ? data : {};
        let result = new Operator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinetCount"] = this.cabinetCount;
        data["interventionCount"] = this.interventionCount;
        data["memberCount"] = this.memberCount;
        if (Array.isArray(this.operatorsAsCommercialOperator)) {
            data["operatorsAsCommercialOperator"] = [];
            for (let item of this.operatorsAsCommercialOperator)
                data["operatorsAsCommercialOperator"].push(item.toJSON());
        }
        data["partnerCount"] = this.partnerCount;
        data["technicianCount"] = this.technicianCount;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type Operator. */
export interface IOperator extends IOperatorLight {
    /** Gets or sets the cabinet count. */
    cabinetCount: number;
    /** Gets or sets the intervention count. */
    interventionCount: number;
    /** Gets or sets the member count. */
    memberCount: number;
    /** Gets or sets the operators as commercial operator. */
    operatorsAsCommercialOperator?: OperatorLight[] | undefined;
    /** Gets or sets the partner count. */
    partnerCount: number;
    /** Gets or sets the technician count. */
    technicianCount: number;
}

/** Contains the definition of an object of type OperatorSearchParams. */
export class OperatorSearchParams implements IOperatorSearchParams {
    /** Gets or sets the cabinet identifier. */
    cabinetId?: number | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the operator ids. */
    ids?: number[] | undefined;
    /** Gets or sets the operator ids as commercial operator. */
    operatorIdsAsCommercialOperator?: number[] | undefined;
    /** Gets or sets a value indicating whether this instance can operator create cabinet. */
    onlyCanAddOrEditCabinet!: boolean;

    constructor(data?: IOperatorSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cabinetId = _data["cabinetId"];
            this.name = _data["name"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["operatorIdsAsCommercialOperator"])) {
                this.operatorIdsAsCommercialOperator = [] as any;
                for (let item of _data["operatorIdsAsCommercialOperator"])
                    this.operatorIdsAsCommercialOperator!.push(item);
            }
            this.onlyCanAddOrEditCabinet = _data["onlyCanAddOrEditCabinet"];
        }
    }

    static fromJS(data: any): OperatorSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinetId"] = this.cabinetId;
        data["name"] = this.name;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.operatorIdsAsCommercialOperator)) {
            data["operatorIdsAsCommercialOperator"] = [];
            for (let item of this.operatorIdsAsCommercialOperator)
                data["operatorIdsAsCommercialOperator"].push(item);
        }
        data["onlyCanAddOrEditCabinet"] = this.onlyCanAddOrEditCabinet;
        return data;
    }
}

/** Contains the definition of an object of type OperatorSearchParams. */
export interface IOperatorSearchParams {
    /** Gets or sets the cabinet identifier. */
    cabinetId?: number | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the operator ids. */
    ids?: number[] | undefined;
    /** Gets or sets the operator ids as commercial operator. */
    operatorIdsAsCommercialOperator?: number[] | undefined;
    /** Gets or sets a value indicating whether this instance can operator create cabinet. */
    onlyCanAddOrEditCabinet: boolean;
}

/** Contains the definition of an object of type OperatorPaginatedSearchParams. */
export class OperatorPaginatedSearchParams extends OperatorSearchParams implements IOperatorPaginatedSearchParams {
    /** Gets or sets the page. 0 is the first page. */
    page!: number;
    /** Gets or sets the size of the page. */
    pageSize!: number;

    constructor(data?: IOperatorPaginatedSearchParams) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): OperatorPaginatedSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorPaginatedSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type OperatorPaginatedSearchParams. */
export interface IOperatorPaginatedSearchParams extends IOperatorSearchParams {
    /** Gets or sets the page. 0 is the first page. */
    page: number;
    /** Gets or sets the size of the page. */
    pageSize: number;
}

/** Contains the definition of an object of type UpdateOperator. */
export class UpdateOperator extends BaseEditOperator implements IUpdateOperator {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdateOperator) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateOperator {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOperator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateOperator. */
export interface IUpdateOperator extends IBaseEditOperator {
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type LoginRequest. */
export class LoginRequest implements ILoginRequest {
    /** Gets or sets the password. */
    password!: string;
    /** Gets or sets the username. */
    username!: string;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["username"] = this.username;
        return data;
    }
}

/** Contains the definition of an object of type LoginRequest. */
export interface ILoginRequest {
    /** Gets or sets the password. */
    password: string;
    /** Gets or sets the username. */
    username: string;
}

/** Contains the definition of an object of type AskNewPasswordRequest. */
export class AskNewPasswordRequest implements IAskNewPasswordRequest {
    /** Gets or sets the email. */
    email?: string | undefined;

    constructor(data?: IAskNewPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AskNewPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AskNewPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

/** Contains the definition of an object of type AskNewPasswordRequest. */
export interface IAskNewPasswordRequest {
    /** Gets or sets the email. */
    email?: string | undefined;
}

/** Contains the definition of an object of type ResetPasswordRequest. */
export class ResetPasswordRequest implements IResetPasswordRequest {
    /** Gets or sets the password. */
    password?: string | undefined;
    /** Gets or sets the token. */
    token?: string | undefined;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["token"] = this.token;
        return data;
    }
}

/** Contains the definition of an object of type ResetPasswordRequest. */
export interface IResetPasswordRequest {
    /** Gets or sets the password. */
    password?: string | undefined;
    /** Gets or sets the token. */
    token?: string | undefined;
}

/** Contains the definition of an object of type CurrentMember. */
export class CurrentMember implements ICurrentMember {
    /** Gets or sets a value indicating whether this instance can add or update cabinet. */
    canAddOrEditCabinet!: boolean;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the groups. */
    groups?: string[] | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the managed commercial operator ids. */
    managedCommercialOperatorIds?: number[] | undefined;
    /** Gets or sets the managed operator identifiers. */
    managedOperatorIds?: number[] | undefined;

    constructor(data?: ICurrentMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAddOrEditCabinet = _data["canAddOrEditCabinet"];
            this.firstName = _data["firstName"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
            this.id = _data["id"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["managedCommercialOperatorIds"])) {
                this.managedCommercialOperatorIds = [] as any;
                for (let item of _data["managedCommercialOperatorIds"])
                    this.managedCommercialOperatorIds!.push(item);
            }
            if (Array.isArray(_data["managedOperatorIds"])) {
                this.managedOperatorIds = [] as any;
                for (let item of _data["managedOperatorIds"])
                    this.managedOperatorIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CurrentMember {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAddOrEditCabinet"] = this.canAddOrEditCabinet;
        data["firstName"] = this.firstName;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["id"] = this.id;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.managedCommercialOperatorIds)) {
            data["managedCommercialOperatorIds"] = [];
            for (let item of this.managedCommercialOperatorIds)
                data["managedCommercialOperatorIds"].push(item);
        }
        if (Array.isArray(this.managedOperatorIds)) {
            data["managedOperatorIds"] = [];
            for (let item of this.managedOperatorIds)
                data["managedOperatorIds"].push(item);
        }
        return data;
    }
}

/** Contains the definition of an object of type CurrentMember. */
export interface ICurrentMember {
    /** Gets or sets a value indicating whether this instance can add or update cabinet. */
    canAddOrEditCabinet: boolean;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the groups. */
    groups?: string[] | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the managed commercial operator ids. */
    managedCommercialOperatorIds?: number[] | undefined;
    /** Gets or sets the managed operator identifiers. */
    managedOperatorIds?: number[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}